// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Elegant Maderas Theme Variables */
.maderas-elegant {
  /* Common Brand Colors */
  --elegant-gold: #c5a059;
  --elegant-gold-light: #e2c08d;
  --elegant-gold-dark: #8e6d31;
  --elegant-gold-gradient: linear-gradient(
    135deg,
    #c5a059 0%,
    #f1d38e 50%,
    #8e6d31 100%
  );
  /* Default Dark Theme Variables */
  --theme-bg: #0d0d0d;
  --theme-card-bg: #111111;
  --theme-card-sub-bg: #1a1a1a;
  --theme-text-primary: #ffffff;
  --theme-text-secondary: #999999;
  --theme-text-muted: #777777;
  --theme-glass-bg: rgba(26, 26, 26, 0.85);
  --theme-glass-border: rgba(197, 160, 89, 0.3);
  --theme-input-bg: rgba(255, 255, 255, 0.05);
  --theme-nav-inactive-bg: rgba(255, 255, 255, 0.04);
  --theme-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
  --theme-border-subtle: rgba(255, 255, 255, 0.05);
}

/* Light Theme Overrides */
.maderas-elegant.light-theme {
  --theme-bg: #f8f9fa;
  --theme-card-bg: #ffffff;
  --theme-card-sub-bg: #f1f3f5;
  --theme-text-primary: #1a1a1a;
  --theme-text-secondary: #495057;
  --theme-text-muted: #868e96;
  --theme-glass-bg: rgba(255, 255, 255, 0.9);
  --theme-glass-border: rgba(197, 160, 89, 0.4);
  --theme-input-bg: rgba(0, 0, 0, 0.03);
  --theme-nav-inactive-bg: rgba(0, 0, 0, 0.05);
  --theme-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  --theme-border-subtle: rgba(0, 0, 0, 0.05);
}

.maderas-elegant {
  background-color: var(--theme-bg) !important;
  background-image: var(--maderas-background-image) !important;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--theme-text-primary) !important;
  font-family: "Poppins", sans-serif;
  min-height: 100vh;
  transition: background-color 0.4s ease, color 0.4s ease;
}

/* Header / Logo Area */
.maderas-elegant .bostami-header-area {
  padding-top: 40px;
  margin-bottom: 50px;
}

.maderas-elegant .bostami-header-wrap {
  background: transparent !important;
}

.maderas-header-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.theme-toggle-btn-wrap {
  position: absolute;
  top: 0;
  right: 20px;
  z-index: 100;
}

.theme-toggle-btn {
  background: var(--theme-glass-bg);
  border: 1px solid var(--theme-glass-border);
  color: var(--elegant-gold);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.theme-toggle-btn:hover {
  transform: scale(1.1);
  background: var(--theme-card-sub-bg);
  border-color: var(--elegant-gold);
  color: var(--elegant-gold-light);
}

.maderas-logo-arc {
  position: absolute;
  top: -30px;
  width: 250px;
  height: 120px;
  border-top: 2px solid var(--elegant-gold);
  border-radius: 125px 125px 0 0;
  opacity: 0.5;
  box-shadow: 0 -5px 15px rgba(197, 160, 89, 0.2);
}

.maderas-elegant .bostami-header-logo {
  text-align: center;
  z-index: 10;
  padding: 10px 0;
}

.maderas-elegant .bostami-header-logo img {
  margin-left: 0 !important;
  max-width: 100%;
  height: auto;
}

/* Shiny effect for gold buttons and active items */
@keyframes shiny {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.maderas-elegant .form-btn,
.maderas-elegant .bastami-main-menu ul li.active {
  background-size: 200% 200% !important;
  animation: shiny 3s ease infinite !important;
}

/* Personal Info Card */
.maderas-elegant .bostami-parsonal-info-area {
  background: var(--theme-card-bg) !important; /* Theme-aware background */
  border: 1px solid var(--theme-border-subtle) !important;
  border-radius: 20px;
  padding: 30px;
  box-shadow: var(--theme-shadow);
  margin-top: 0;
}

.maderas-elegant .bostami-parsonal-info-wrap {
  text-align: center;
}

.maderas-elegant .bostami-parsonal-info-img {
  position: relative;
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
}

.maderas-elegant .bostami-parsonal-info-img img {
  border: 2px solid var(--elegant-gold) !important;
  padding: 10px;
  border-radius: 25px !important;
  background: transparent !important;
}

.maderas-elegant .bostami-parsonal-info-name {
  color: var(--theme-text-primary) !important;
  font-family: "Roboto Slab", serif;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
}

.maderas-elegant .bostami-parsonal-info-bio {
  color: var(--theme-text-primary) !important; /* Higher contrast */
  background: var(--theme-card-sub-bg) !important;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 2px;
  text-align: center;
  display: inline-block;
  margin: 0 auto 20px;
  padding: 5px 25px;
  border-radius: 30px;
  border: 1px solid var(--theme-border-subtle);
}

/* Ensure the contact wrap itself is transparent to avoid dark boxes from base theme */
.maderas-elegant .bostami-parsonal-info-contact {
  background: transparent !important;
  padding: 0 !important;
  border: none !important;
}

.maderas-elegant .bostami-parsonal-info-contact-item {
  background: var(--theme-card-sub-bg) !important; /* Theme-aware box */
  border-radius: 12px;
  margin-bottom: 15px;
  padding: 10px 10px;
  border: 1px solid var(--theme-border-subtle);
  display: flex;
  align-items: center;
  gap: 8px;
}

.maderas-elegant .bostami-parsonal-info-contact-item .icon {
  background: rgba(197, 160, 89, 0.2) !important; /* Goldish background box */
  width: 38px; /* Slightly smaller icon box */
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  min-width: 38px;
  -webkit-text-fill-color: initial !important;
  background-clip: initial !important;
  -webkit-background-clip: initial !important;
}

.maderas-elegant .bostami-parsonal-info-contact-item .icon i {
  color: var(--elegant-gold-light) !important;
  font-size: 16px;
}

.maderas-elegant .bostami-parsonal-info-contact-item .text {
  display: flex;
  flex-direction: column;
  min-width: 0; /* Important for flex child to allow inner content to shrink */
}

.maderas-elegant .bostami-parsonal-info-contact-item .text span {
  color: var(--theme-text-muted) !important;
  text-transform: uppercase;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 1px;
}

.maderas-elegant .bostami-parsonal-info-contact-item .text p,
.maderas-elegant .bostami-parsonal-info-contact-item .text a {
  color: var(--theme-text-primary) !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  margin: 0 !important;
  white-space: nowrap;
}

.maderas-elegant .bostami-parsonal-info-social-link li a {
  background: var(--theme-border-subtle) !important;
  color: var(--elegant-gold) !important;
  transition: 0.3s;
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.maderas-elegant .bostami-parsonal-info-social-link {
  gap: 10px;
}

/* Navigation / Tabs */
.maderas-elegant .bostami-main-menu-wrap {
  background: var(--theme-glass-bg) !important;
  border: 1px solid var(--theme-glass-border) !important;
  border-radius: 15px;
  padding: 10px;
}

.maderas-elegant .bastami-main-menu ul {
  background: transparent !important;
  display: flex;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
}

.maderas-elegant .bastami-main-menu ul li {
  margin: 0 5px;
  border-radius: 12px;
  transition: 0.3s;
  color: var(--theme-text-secondary) !important;
  cursor: pointer;
  width: 105px;
  padding: 12px 0;
  background: var(--theme-nav-inactive-bg) !important;
  border: 1px solid var(--theme-border-subtle);
}

.maderas-elegant .bastami-main-menu ul li:hover {
  background: var(--theme-border-subtle) !important;
  color: var(--theme-text-primary) !important;
}

.maderas-elegant .menu-item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.maderas-elegant .menu-item-content .icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.maderas-elegant .bastami-main-menu ul li.active {
  background: var(--elegant-gold-gradient) !important;
  color: #fff !important;
  box-shadow: 0 5px 15px rgba(197, 160, 89, 0.3);
}

.maderas-elegant .bastami-main-menu ul li.active i {
  color: #fff !important;
}

/* Content Area */
.maderas-elegant .bostami-page-content-wrap {
  background: var(--theme-glass-bg) !important;
  border: 1px solid var(--theme-glass-border) !important;
  border-radius: 20px;
  color: var(--theme-text-primary);
  overflow: hidden;
  position: relative;
}

.maderas-elegant .section-wrapper {
  background: transparent !important;
}

.maderas-elegant .bg-light-white-2 {
  background: var(--theme-input-bg) !important;
  border-top: 1px solid var(--theme-glass-border);
}

.maderas-elegant .page-title,
.maderas-elegant .section-title {
  font-family: "Roboto Slab", serif;
  color: var(--elegant-gold-light) !important;
  font-weight: 700;
}

.maderas-elegant .bostami-page-title-wrap p,
.maderas-elegant .section-wrapper p {
  color: var(--theme-text-primary) !important;
  opacity: 0.9;
}

.maderas-elegant .bostami-page-title-wrap::after {
  content: "";
  display: block;
  width: 60px;
  height: 3px;
  background: var(--elegant-gold-gradient);
  margin-top: 10px;
}

/* Sparkle effect like in the image */
.maderas-elegant .bostami-page-content-wrap::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-image: radial-gradient(circle at 10% 20%, rgba(197, 160, 89, 0.1) 1px, transparent 1px), radial-gradient(circle at 30% 50%, rgba(197, 160, 89, 0.1) 1px, transparent 1px), radial-gradient(circle at 70% 30%, rgba(197, 160, 89, 0.1) 1px, transparent 1px), radial-gradient(circle at 90% 70%, rgba(197, 160, 89, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  opacity: 0.5;
}

.maderas-elegant .bostami-client-slider-logo {
  filter: none !important;
  opacity: 1 !important;
}

.maderas-elegant .contact-area {
  background: transparent !important;
  padding: 20px 0;
}

.maderas-elegant .form-input-item label {
  color: var(--elegant-gold-light) !important;
  font-size: 14px;
  font-weight: 500;
}

.maderas-elegant .form-input-item .input-box {
  background: var(--theme-input-bg) !important;
  border: 1px solid var(--theme-glass-border) !important;
  border-radius: 10px !important;
  color: var(--theme-text-primary) !important;
  padding: 12px 15px !important;
  transition: 0.3s;
}

.maderas-elegant .form-input-item .input-box:focus {
  border-color: var(--elegant-gold) !important;
  box-shadow: 0 0 10px rgba(197, 160, 89, 0.2) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}

.maderas-elegant .form-btn {
  background: var(--elegant-gold-gradient) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 30px !important;
  padding: 12px 35px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 5px 15px rgba(197, 160, 89, 0.3) !important;
  transition: 0.3s;
}

.maderas-elegant .form-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(197, 160, 89, 0.4) !important;
}

.maderas-elegant .footer-copyright {
  background: rgba(0, 0, 0, 0.05) !important;
  border-top: 1px solid var(--theme-glass-border) !important;
  color: var(--theme-text-muted) !important;
}

/* Portfolio grid elegance */
.maderas-elegant .portfolio-item-wrap {
  background: var(--theme-input-bg) !important;
  border: 1px solid var(--theme-glass-border) !important;
  border-radius: 15px !important;
  padding: 15px;
  transition: 0.3s;
}

.maderas-elegant .portfolio-item-wrap:hover {
  border-color: var(--elegant-gold) !important;
  transform: translateY(-5px);
}

/* Portfolio filters */
.maderas-elegant .fillter-btn-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  row-gap: 15px; /* Spacing between rows when buttons wrap */
  justify-content: center;
  padding: 0 10px;
}

.maderas-elegant .fillter-btn {
  background: var(--theme-input-bg) !important;
  border: 1px solid var(--theme-glass-border) !important;
  color: var(--theme-text-secondary) !important;
  padding: 8px 20px !important;
  border-radius: 20px !important;
  cursor: pointer;
  transition: 0.3s;
}

.maderas-elegant .fillter-btn:hover,
.maderas-elegant .fillter-btn.is-checked {
  background: var(--elegant-gold-gradient) !important;
  color: #fff !important;
  border-color: transparent !important;
}

.maderas-elegant .fillter-item {
  background: var(--theme-input-bg) !important;
  border: 1px solid var(--theme-glass-border) !important;
  border-radius: 15px !important;
  padding: 15px !important;
  margin-bottom: 20px;
  transition: 0.3s;
}

.maderas-elegant .fillter-item .item-title {
  color: var(--elegant-gold-light) !important;
  font-weight: 600;
  margin-top: 15px;
}

.maderas-elegant .fillter-item .item-subtitle {
  color: var(--theme-text-muted) !important;
  font-size: 13px;
}

.maderas-elegant .fillter-item .img {
  border-radius: 10px;
  overflow: hidden;
  display: block;
}

/* Elegant curve background element (Top Right) */
.elegant-curve-bg {
  position: fixed;
  top: -200px;
  right: -300px;
  width: 800px;
  height: 1200px;
  border-left: 1.5px solid rgba(197, 160, 89, 0.25);
  border-radius: 50%;
  transform: rotate(-15deg);
  pointer-events: none;
  z-index: 0; /* Ensure it stays behind content but visible on background */
}

/* Elegant curve background element (Bottom Left) */
.elegant-curve-bg-2 {
  position: fixed;
  bottom: -300px;
  left: -400px;
  width: 1000px;
  height: 1000px;
  border-right: 1.5px solid rgba(197, 160, 89, 0.2);
  border-radius: 50%;
  transform: rotate(-10deg);
  pointer-events: none;
  z-index: 0;
}

/* Extra decorative lines like in the image */
.maderas-elegant .bostami-parsonal-info-wrap::before {
  content: "";
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  background-image: radial-gradient(var(--elegant-gold) 1px, transparent 1px);
  background-size: 8px 8px;
  opacity: 0.3;
}

/* Responsive Navigation for Mobile */
@media (max-width: 991px) {
  .maderas-elegant.home-3 .bostami-main-menu-wrap,
  .maderas-elegant .home-3 .bostami-main-menu-wrap {
    display: block !important;
    margin: 0 auto 30px !important;
    width: 100% !important;
    float: none !important;
  }
  .maderas-elegant .bastami-main-menu ul {
    display: flex !important;
    justify-content: space-between !important;
    width: 100%;
    padding: 0 5px;
  }
  .maderas-elegant .bastami-main-menu ul li {
    width: calc(33.33% - 8px) !important;
    margin: 0 4px !important;
    padding: 12px 0 !important;
    height: auto !important;
    min-width: unset !important;
  }
  .maderas-elegant .menu-item-content .icon {
    font-size: 22px !important;
    margin-bottom: 6px !important;
  }
  .maderas-elegant .menu-item-content .text {
    font-size: 10px !important;
    font-weight: 500;
    text-transform: capitalize;
    white-space: nowrap;
  }
  /* Hide the default mobile hamburger menu if it exists, as we are using the tabs */
  .maderas-elegant .mobile-menu-btn,
  .maderas-elegant .mobile-menu-wrap {
    display: none !important;
  }
}
/* QR View Specific Styles */
.qr-view-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  min-height: 100vh !important;
  padding: 40px 20px !important;
  position: relative;
  overflow: hidden;
}

.qr-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;
  width: 100%;
  max-width: 400px;
  position: relative;
}

.qr-theme-toggle {
  top: -50px;
  right: 0;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-area {
  margin-top: 100px !important;
  width: 100% !important;
  max-width: 380px !important;
  position: relative;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-img {
  position: absolute !important;
  top: -110px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0 !important;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-img img {
  width: 200px !important;
  height: 200px !important;
  object-fit: cover;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-name {
  margin-top: 100px !important; /* Push down after absolutely positioned image */
  margin-bottom: 25px !important;
}

.qr-code-container {
  background: var(--theme-input-bg);
  padding: 20px;
  border-radius: 20px;
  border: 1px solid var(--theme-glass-border);
  margin-bottom: 30px;
  box-shadow: 0 0 20px rgba(197, 160, 89, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-code-canvas {
  filter: drop-shadow(0 0 5px rgba(197, 160, 89, 0.3));
}

.qr-footer-logo {
  margin-top: 40px;
  opacity: 0.8;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact {
  width: 100% !important;
  padding: 0 5px !important; /* Reduced side padding to gain space */
  background-color: transparent !important; /* Fix the white box */
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item {
  padding: 12px 15px !important;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .text a {
  white-space: normal !important; /* Allow wrapping */
  word-break: break-all !important;
  line-height: 1.2;
}

/* Ensure curve animations are subtle in QR view too */
.maderas-elegant.qr-view-container .elegant-curve-bg,
.maderas-elegant.qr-view-container .elegant-curve-bg-2 {
  opacity: 0.6;
}

/* Living Maderas premium card redesign */
.maderas-elegant.home-3 {
  --living-navy: #071526;
  --living-slate: #142b43;
  --living-gold: #d8b978;
  --living-gold-soft: #f0d99d;
  --living-text: #f8fbff;
  --living-text-soft: rgba(234, 242, 250, 0.78);
  --living-text-muted: rgba(224, 234, 244, 0.58);
  --living-skeleton-base: rgba(204, 225, 242, 0.1);
  --living-skeleton-highlight: rgba(241, 248, 255, 0.26);
  --living-glass: linear-gradient(
    145deg,
    rgba(39, 62, 87, 0.58) 0%,
    rgba(8, 25, 43, 0.46) 55%,
    rgba(5, 18, 33, 0.58) 100%
  );
  --living-glass-strong: linear-gradient(
    150deg,
    rgba(44, 67, 91, 0.72) 0%,
    rgba(8, 26, 45, 0.66) 62%,
    rgba(5, 18, 33, 0.74) 100%
  );
  --living-glass-soft: rgba(164, 191, 216, 0.1);
  --living-border: rgba(227, 239, 250, 0.34);
  --living-border-soft: rgba(227, 239, 250, 0.16);
  --living-shadow: 0 28px 70px rgba(0, 8, 20, 0.36);
  --theme-card-bg: rgba(9, 27, 46, 0.62);
  --theme-card-sub-bg: rgba(174, 199, 221, 0.1);
  --theme-text-primary: var(--living-text);
  --theme-text-secondary: var(--living-text-soft);
  --theme-text-muted: var(--living-text-muted);
  --theme-glass-bg: rgba(10, 29, 49, 0.58);
  --theme-glass-border: var(--living-border);
  --theme-input-bg: rgba(193, 214, 232, 0.09);
  --theme-nav-inactive-bg: rgba(175, 202, 224, 0.08);
  --theme-shadow: var(--living-shadow);
  --theme-border-subtle: var(--living-border-soft);
  position: relative;
  height: 100vh;
  min-height: 100vh;
  padding: 24px 0 34px;
  overflow-x: hidden;
  overflow-y: auto;
  background-attachment: fixed;
  isolation: isolate;
}

.maderas-elegant.home-3.light-theme {
  --living-text: #11263b;
  --living-text-soft: rgba(17, 38, 59, 0.78);
  --living-text-muted: rgba(17, 38, 59, 0.6);
  --living-skeleton-base: rgba(40, 78, 110, 0.1);
  --living-skeleton-highlight: rgba(255, 255, 255, 0.7);
  --living-glass: linear-gradient(
    145deg,
    rgba(247, 251, 255, 0.76) 0%,
    rgba(226, 238, 248, 0.62) 58%,
    rgba(213, 229, 241, 0.7) 100%
  );
  --living-glass-strong: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0.86) 0%,
    rgba(229, 240, 249, 0.76) 100%
  );
  --living-glass-soft: rgba(255, 255, 255, 0.42);
  --living-border: rgba(255, 255, 255, 0.7);
  --living-border-soft: rgba(255, 255, 255, 0.46);
  --living-shadow: 0 26px 66px rgba(6, 27, 47, 0.22);
  --theme-card-bg: rgba(241, 248, 253, 0.74);
  --theme-card-sub-bg: rgba(255, 255, 255, 0.44);
  --theme-text-primary: var(--living-text);
  --theme-text-secondary: var(--living-text-soft);
  --theme-text-muted: var(--living-text-muted);
  --theme-glass-bg: rgba(236, 246, 253, 0.7);
  --theme-glass-border: var(--living-border);
  --theme-input-bg: rgba(255, 255, 255, 0.42);
  --theme-nav-inactive-bg: rgba(255, 255, 255, 0.38);
  --theme-shadow: var(--living-shadow);
  --theme-border-subtle: var(--living-border-soft);
}

.maderas-elegant.home-3 .living-background-overlay {
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(1, 12, 27, 0.58) 0%, rgba(4, 18, 34, 0.34) 31%, rgba(7, 22, 38, 0.08) 57%, rgba(2, 14, 29, 0.26) 100%), linear-gradient(180deg, rgba(2, 13, 27, 0.22) 0%, transparent 42%, rgba(1, 10, 22, 0.44) 100%);
}

.maderas-elegant.home-3.light-theme .living-background-overlay {
  background: linear-gradient(90deg, rgba(9, 27, 47, 0.34) 0%, rgba(16, 37, 57, 0.12) 45%, rgba(7, 23, 40, 0.18) 100%), linear-gradient(180deg, rgba(209, 228, 242, 0.08) 0%, transparent 50%, rgba(3, 17, 32, 0.24) 100%);
}

.maderas-elegant.home-3 .living-dashboard {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: minmax(330px, 366px) minmax(0, 1fr);
  grid-template-areas: "brand navigation" "profile content";
  column-gap: clamp(30px, 4.2vw, 68px);
  row-gap: 20px;
  width: min(100% - 40px, 1280px);
  max-width: 1280px;
  min-height: calc(100vh - 58px);
  margin: 0 auto;
  padding: 0;
  align-content: start;
}

.maderas-elegant.home-3 .living-skeleton {
  display: block;
  overflow: hidden;
  background: linear-gradient(100deg, transparent 20%, var(--living-skeleton-highlight) 42%, transparent 64%) 100% 0/220% 100%, var(--living-skeleton-base);
  border: 1px solid var(--living-border-soft);
  animation: living-skeleton-shimmer 1.5s ease-in-out infinite;
}

.maderas-elegant.home-3 .living-loading-navigation__inner {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
  width: 100%;
  padding: 7px;
  background: var(--living-glass);
  border: 1px solid var(--living-border);
  border-radius: 23px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22), 0 20px 48px rgba(0, 8, 20, 0.24);
  backdrop-filter: blur(22px) saturate(125%);
  -webkit-backdrop-filter: blur(22px) saturate(125%);
}

.maderas-elegant.home-3 .living-loading-navigation__inner > span {
  min-height: 56px;
  border-radius: 16px;
}

.maderas-elegant.home-3 .living-loading-profile {
  display: flex;
  min-height: 560px;
  flex-direction: column;
  align-items: center;
}

.maderas-elegant.home-3 .living-loading-photo {
  width: min(100%, 258px);
  height: clamp(220px, 20vw, 258px);
  margin-bottom: 18px;
  border-color: rgba(241, 215, 154, 0.42);
  border-radius: 30px;
}

.maderas-elegant.home-3 .living-loading-name {
  width: min(78%, 230px);
  height: 30px;
  margin-bottom: 10px;
  border-radius: 9px;
}

.maderas-elegant.home-3 .living-loading-badge {
  width: 88px;
  height: 30px;
  margin-bottom: 14px;
  border-radius: 999px;
}

.maderas-elegant.home-3 .living-loading-socials {
  display: flex;
  min-height: 44px;
  margin-bottom: 18px;
  gap: 9px;
}

.maderas-elegant.home-3 .living-loading-socials > span {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}

.maderas-elegant.home-3 .living-loading-heading {
  align-self: flex-start;
  width: 104px;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 7px;
}

.maderas-elegant.home-3 .living-loading-contacts {
  width: 100%;
}

.maderas-elegant.home-3 .living-loading-contact {
  display: flex;
  min-height: 64px;
  margin-bottom: 10px;
  padding: 10px 12px;
  align-items: center;
  gap: 12px;
  background: rgba(196, 217, 234, 0.07);
  border: 1px solid var(--living-border-soft);
  border-radius: 16px;
}

.maderas-elegant.home-3 .living-loading-contact:last-child {
  margin-bottom: 0;
}

.maderas-elegant.home-3 .living-loading-contact__icon {
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  border-radius: 13px;
}

.maderas-elegant.home-3 .living-loading-contact__text {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
}

.maderas-elegant.home-3 .living-loading-contact__text > span:first-child {
  width: 38%;
  height: 8px;
  border-radius: 4px;
}

.maderas-elegant.home-3 .living-loading-contact__text > span:last-child {
  width: 78%;
  height: 12px;
  border-radius: 5px;
}

.maderas-elegant.home-3 .living-loading-content__card {
  display: flex;
  min-height: 485px;
  padding: clamp(34px, 4vw, 52px) clamp(30px, 4.4vw, 58px);
  flex-direction: column;
  color: var(--living-text);
  background: var(--living-glass);
  border: 1px solid var(--living-border);
  border-radius: 30px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.28), var(--living-shadow);
  backdrop-filter: blur(25px) saturate(120%);
  -webkit-backdrop-filter: blur(25px) saturate(120%);
}

.maderas-elegant.home-3 .living-loading-copy {
  width: 100%;
}

.maderas-elegant.home-3 .living-loading-title {
  width: min(44%, 250px);
  height: 44px;
  margin-bottom: 16px;
  border-radius: 11px;
}

.maderas-elegant.home-3 .living-loading-rule {
  width: min(28%, 150px);
  height: 3px;
  margin-bottom: 26px;
  border: 0;
  border-radius: 999px;
}

.maderas-elegant.home-3 .living-loading-line {
  width: 100%;
  height: 13px;
  margin-bottom: 13px;
  border: 0;
  border-radius: 6px;
}

.maderas-elegant.home-3 .living-loading-line--short-1 {
  width: 64%;
  margin-bottom: 28px;
}

.maderas-elegant.home-3 .living-loading-line--medium {
  width: 76%;
}

.maderas-elegant.home-3 .living-loading-message {
  display: flex;
  width: fit-content;
  max-width: 100%;
  margin-top: auto;
  padding: 13px 16px;
  align-items: center;
  gap: 12px;
  color: var(--living-text);
  background: var(--living-glass-soft);
  border: 1px solid var(--living-border-soft);
  border-radius: 16px;
}

.maderas-elegant.home-3 .living-loading-message > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.maderas-elegant.home-3 .living-loading-message strong {
  font-size: 13px;
  font-weight: 600;
}

.maderas-elegant.home-3 .living-loading-message small {
  color: var(--living-text-soft);
  font-size: 11px;
  line-height: 1.45;
}

.maderas-elegant.home-3 .living-loading-spinner {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border: 2px solid var(--living-border);
  border-top-color: var(--living-gold);
  border-radius: 50%;
  animation: living-loading-spin 800ms linear infinite;
}

.maderas-elegant.home-3 .living-request-error {
  grid-column: 1/-1;
  width: min(100%, 620px);
  margin: clamp(54px, 10vh, 100px) auto 0;
  padding: clamp(30px, 5vw, 48px);
  color: var(--living-text);
  text-align: center;
  background: var(--living-glass-strong);
  border: 1px solid var(--living-border);
  border-radius: 30px;
  box-shadow: var(--living-shadow);
  backdrop-filter: blur(24px) saturate(125%);
  -webkit-backdrop-filter: blur(24px) saturate(125%);
}

.maderas-elegant.home-3 .living-request-error__icon {
  display: grid;
  width: 58px;
  height: 58px;
  margin: 0 auto 20px;
  place-items: center;
  color: var(--living-gold-soft);
  font-size: 25px;
  background: var(--living-glass-soft);
  border: 1px solid var(--living-border);
  border-radius: 18px;
}

.maderas-elegant.home-3 .living-request-error h1 {
  margin: 0 0 10px;
  color: var(--living-text);
  font-family: "Roboto Slab", serif;
  font-size: clamp(25px, 4vw, 34px);
  font-weight: 500;
}

.maderas-elegant.home-3 .living-request-error p {
  margin: 0 auto 24px;
  color: var(--living-text-soft);
  font-size: 14px;
}

.maderas-elegant.home-3 .living-retry-button {
  display: inline-flex;
  min-height: 46px;
  padding: 11px 20px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #ffffff;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  background: linear-gradient(145deg, rgba(63, 132, 181, 0.94), rgba(16, 72, 119, 0.92));
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 14px;
  box-shadow: 0 10px 22px rgba(10, 67, 111, 0.28);
  cursor: pointer;
  transition: transform 200ms ease, box-shadow 200ms ease;
}

.maderas-elegant.home-3 .living-retry-button:hover {
  color: #ffffff;
  box-shadow: 0 13px 26px rgba(10, 67, 111, 0.36);
  transform: translateY(-2px);
}

@keyframes living-skeleton-shimmer {
  to {
    background-position: -120% 0;
  }
}
@keyframes living-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
.maderas-elegant.home-3 .living-brand-bar {
  position: relative;
  grid-area: brand;
  display: block;
  min-width: 0;
}

.maderas-elegant.home-3 .living-brand-lockup,
.maderas-elegant.qr-view-container .living-brand-lockup {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 86px;
  padding: 12px 24px;
  overflow: hidden;
  color: var(--living-text);
  background: var(--living-glass);
  border: 1px solid var(--living-border);
  border-radius: 24px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 0 0 1px rgba(180, 216, 244, 0.08), 0 0 24px rgba(136, 190, 229, 0.12), var(--living-shadow);
  backdrop-filter: blur(18px) saturate(125%);
  -webkit-backdrop-filter: blur(18px) saturate(125%);
  transition: transform 220ms ease, border-color 220ms ease, background-color 220ms ease;
}

.maderas-elegant.home-3 .living-brand-lockup::before,
.maderas-elegant.qr-view-container .living-brand-lockup::before {
  content: "";
  position: absolute;
  inset: -1px;
  z-index: 3;
  pointer-events: none;
  border-radius: inherit;
  background: linear-gradient(90deg, transparent 4%, rgba(235, 248, 255, 0.9) 15%, transparent 31%) top left/100% 1.5px no-repeat, linear-gradient(90deg, transparent 52%, rgba(238, 205, 137, 0.72) 72%, transparent 94%) bottom left/100% 1.5px no-repeat, linear-gradient(180deg, transparent 7%, rgba(226, 244, 255, 0.7) 24%, transparent 43%) top left/1.5px 100% no-repeat, linear-gradient(180deg, transparent 48%, rgba(238, 205, 137, 0.58) 76%, transparent 94%) top right/1.5px 100% no-repeat;
  filter: drop-shadow(0 0 5px rgba(203, 231, 250, 0.34));
}

.maderas-elegant.home-3 .living-brand-lockup::after,
.maderas-elegant.qr-view-container .living-brand-lockup::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(115deg, rgba(255, 255, 255, 0.14), transparent 32%);
}

.maderas-elegant.home-3 .living-brand-lockup:hover,
.maderas-elegant.qr-view-container .living-brand-lockup:hover {
  color: var(--living-text);
  border-color: rgba(240, 217, 157, 0.52);
  transform: translateY(-2px);
}

.maderas-elegant.home-3 .living-brand-mark,
.maderas-elegant.qr-view-container .living-brand-mark {
  position: relative;
  display: grid;
  z-index: 1;
  flex: 0 0 60px;
  width: 60px;
  height: 52px;
  place-items: end center;
  margin-right: -36px;
  color: var(--living-gold-soft);
}

.maderas-elegant.home-3 .living-brand-mark::before,
.maderas-elegant.qr-view-container .living-brand-mark::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 11px;
  width: 37px;
  height: 37px;
  border-top: 2px solid var(--living-gold);
  border-left: 2px solid var(--living-gold);
  transform: rotate(45deg);
}

.maderas-elegant.home-3 .living-brand-mark::after,
.maderas-elegant.qr-view-container .living-brand-mark::after {
  content: "";
  position: absolute;
  right: 6px;
  bottom: 0;
  left: 6px;
  height: 28px;
  border-right: 2px solid var(--living-gold);
  border-bottom: 2px solid var(--living-gold);
  border-left: 2px solid var(--living-gold);
}

.maderas-elegant.home-3 .living-brand-copy,
.maderas-elegant.qr-view-container .living-brand-copy {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  min-width: 0;
  line-height: 1;
}

.maderas-elegant.home-3 .living-brand-script,
.maderas-elegant.qr-view-container .living-brand-script {
  margin-right: 8px;
  color: var(--living-text);
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(30px, 2.5vw, 37px);
  font-style: italic;
  font-weight: 400;
  letter-spacing: -0.04em;
}

.maderas-elegant.home-3 .living-brand-copy strong,
.maderas-elegant.qr-view-container .living-brand-copy strong {
  color: var(--living-gold);
  font-family: "Roboto Slab", serif;
  font-size: clamp(18px, 1.5vw, 23px);
  font-weight: 500;
  letter-spacing: 0.02em;
}

.maderas-elegant.home-3 .living-dynamic-brand-logo,
.maderas-elegant.qr-view-container .living-dynamic-brand-logo {
  position: relative;
  z-index: 1;
  display: block;
  width: auto;
  max-width: 230px;
  height: auto;
  max-height: 58px;
  margin: 0 auto;
  object-fit: contain;
}

.maderas-elegant.home-3 .theme-toggle-btn {
  position: absolute;
  top: 50%;
  right: -62px;
  z-index: 3;
  width: 48px;
  height: 48px;
  color: var(--living-gold-soft);
  background: var(--living-glass-strong);
  border: 1px solid var(--living-border);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24), 0 14px 30px rgba(0, 8, 20, 0.28);
  transform: translateY(-50%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.maderas-elegant.home-3 .theme-toggle-btn:hover {
  color: var(--living-gold-soft);
  background: var(--living-glass-strong);
  border-color: rgba(240, 217, 157, 0.58);
  transform: translateY(-50%) scale(1.06);
}

.maderas-elegant.home-3 .living-navigation {
  grid-area: navigation;
  align-self: center;
  justify-self: end;
  width: min(100%, 530px);
}

.maderas-elegant.home-3 .bostami-main-menu-wrap {
  width: 100%;
  padding: 7px;
  background: var(--living-glass) !important;
  border: 1px solid var(--living-border) !important;
  border-radius: 23px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.28), 0 20px 48px rgba(0, 8, 20, 0.3);
  backdrop-filter: blur(22px) saturate(125%);
  -webkit-backdrop-filter: blur(22px) saturate(125%);
}

.maderas-elegant.home-3 .bastami-main-menu ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px;
}

.maderas-elegant.home-3 .bastami-main-menu ul li {
  width: auto;
  min-width: 0;
  height: auto;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: transparent !important;
  border: 0;
  border-radius: 17px;
}

.maderas-elegant.home-3 .bastami-main-menu ul li + li {
  border-left: 1px solid var(--living-border-soft);
  border-radius: 0 17px 17px 0;
}

.maderas-elegant.home-3 .bastami-main-menu .menu-item-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 56px;
  padding: 10px 14px;
  color: var(--living-text-soft);
  font: inherit;
  white-space: nowrap;
  background: transparent;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
  transition: color 200ms ease, background-color 200ms ease, box-shadow 200ms ease, transform 200ms ease;
}

.maderas-elegant.home-3 .menu-item-content .icon {
  display: grid;
  width: 34px;
  height: 34px;
  margin: 0 8px 0 0;
  place-items: center;
  color: var(--living-text-soft);
  font-size: 18px;
  background: rgba(198, 220, 239, 0.08);
  border: 1px solid var(--living-border-soft);
  border-radius: 11px;
  transition: inherit;
}

.maderas-elegant.home-3 .menu-item-content .text {
  font-size: 14px;
  font-weight: 500;
}

.maderas-elegant.home-3 .bastami-main-menu ul li:hover {
  background: transparent !important;
}

.maderas-elegant.home-3 .bastami-main-menu ul li:hover .menu-item-content {
  color: var(--living-text);
  background: rgba(206, 225, 241, 0.09);
}

.maderas-elegant.home-3 .bastami-main-menu ul li.active {
  background: transparent !important;
  box-shadow: none;
  animation: none !important;
}

.maderas-elegant.home-3 .bastami-main-menu ul li.active .menu-item-content {
  color: #ffffff;
  background: linear-gradient(145deg, rgba(63, 132, 181, 0.78), rgba(16, 72, 119, 0.72));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35), 0 8px 18px rgba(10, 67, 111, 0.32);
}

.maderas-elegant.home-3 .bastami-main-menu ul li.active .menu-item-content .icon {
  color: var(--living-gold-soft);
  background: rgba(221, 238, 251, 0.12);
  border-color: rgba(255, 255, 255, 0.22);
}

.maderas-elegant.home-3 .living-profile-column {
  grid-area: profile;
  align-self: start;
  min-width: 0;
}

.maderas-elegant.home-3 .bostami-parsonal-info-area {
  position: relative;
  top: auto;
  width: 100%;
  margin: 0;
  padding: clamp(24px, 2.4vw, 32px);
  overflow: hidden;
  background: var(--living-glass-strong) !important;
  border: 1px solid var(--living-border) !important;
  border-radius: 29px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.34), inset 0 -1px 0 rgba(216, 185, 120, 0.12), -9px 7px 0 -3px rgba(214, 233, 247, 0.14), -24px 16px 44px rgba(1, 12, 28, 0.34), var(--living-shadow);
  backdrop-filter: blur(24px) saturate(125%);
  -webkit-backdrop-filter: blur(24px) saturate(125%);
}

.maderas-elegant.home-3 .bostami-parsonal-info-area::after {
  content: "";
  position: absolute;
  top: -35%;
  left: -20%;
  width: 120%;
  height: 56%;
  pointer-events: none;
  background: radial-gradient(ellipse, rgba(255, 255, 255, 0.2), transparent 65%);
  transform: rotate(-12deg);
}

.maderas-elegant.home-3 .bostami-parsonal-info-wrap {
  position: relative;
  z-index: 1;
  text-align: center;
}

.maderas-elegant.home-3 .bostami-parsonal-info-wrap::before {
  display: none;
}

.maderas-elegant.home-3 .bostami-parsonal-info-img {
  margin: 0 auto 18px;
}

.maderas-elegant.home-3 .bostami-parsonal-info-img img {
  width: min(100%, 258px);
  height: clamp(220px, 20vw, 258px);
  padding: 4px;
  object-fit: cover;
  object-position: center;
  background: rgba(231, 241, 249, 0.12) !important;
  border: 1px solid rgba(241, 215, 154, 0.8) !important;
  border-radius: 30px !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4), 0 16px 32px rgba(0, 8, 20, 0.28), 0 0 24px rgba(216, 185, 120, 0.12);
}

.maderas-elegant.home-3 .bostami-parsonal-info-name {
  max-width: 300px;
  margin: 0 auto 10px;
  color: var(--living-text) !important;
  font-family: "Roboto Slab", serif;
  font-size: clamp(25px, 2.1vw, 31px);
  font-weight: 500;
  line-height: 1.13;
  text-align: center;
  text-transform: none;
  letter-spacing: -0.025em;
  overflow-wrap: anywhere;
}

.maderas-elegant.home-3 .bostami-parsonal-info-bio {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  margin: 0 auto 14px;
  padding: 5px 18px;
  color: var(--living-text) !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  text-transform: none;
  letter-spacing: 0.015em;
  background: linear-gradient(135deg, rgba(245, 226, 184, 0.76), rgba(176, 132, 66, 0.7)) !important;
  border: 1px solid rgba(255, 241, 204, 0.38);
  border-radius: 999px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.36);
}

.maderas-elegant.home-3.light-theme .bostami-parsonal-info-bio {
  color: #ffffff !important;
}

.maderas-elegant.home-3 .bostami-parsonal-info-social-link {
  display: flex;
  width: auto;
  min-height: 44px;
  margin: 0 auto 18px;
  padding: 0;
  gap: 9px;
  justify-content: center;
}

.maderas-elegant.home-3 .bostami-parsonal-info-social-link li a {
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  color: var(--living-text) !important;
  line-height: 1;
  background: rgba(190, 213, 232, 0.12) !important;
  border: 1px solid var(--living-border-soft);
  border-radius: 50%;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15);
  transition: transform 200ms ease, color 200ms ease, background-color 200ms ease, border-color 200ms ease;
}

.maderas-elegant.home-3 .bostami-parsonal-info-social-link li a:hover {
  color: var(--living-gold-soft) !important;
  background: rgba(204, 224, 240, 0.2) !important;
  border-color: rgba(240, 217, 157, 0.44);
  transform: translateY(-3px);
}

.maderas-elegant.home-3 .living-contact-heading {
  display: flex;
  align-items: center;
  margin: 0 0 10px;
  color: var(--living-gold-soft);
  font-family: "Roboto Slab", serif;
  font-size: 18px;
  text-align: left;
}

.maderas-elegant.home-3 .living-contact-heading::before {
  content: "";
  flex: 0 0 26px;
  height: 1px;
  margin-right: 10px;
  background: linear-gradient(90deg, var(--living-gold), transparent);
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact {
  width: 100%;
  margin: 0;
  padding: 0 !important;
  background: transparent !important;
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item {
  min-height: 64px;
  margin: 0 0 10px;
  padding: 10px 12px;
  gap: 12px;
  text-align: left;
  background: linear-gradient(135deg, rgba(196, 217, 234, 0.12), rgba(103, 139, 169, 0.07)) !important;
  border: 1px solid var(--living-border-soft);
  border-radius: 16px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item:last-child {
  margin-bottom: 0;
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .icon {
  display: grid;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  min-width: 42px;
  place-items: center;
  background: linear-gradient(145deg, rgba(238, 247, 255, 0.24), rgba(139, 172, 199, 0.15)) !important;
  border: 1px solid var(--living-border-soft);
  border-radius: 13px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24);
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .icon i {
  color: var(--living-gold-soft) !important;
  font-size: 17px;
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text {
  flex: 1 1;
  min-width: 0;
  align-items: flex-start;
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text span {
  margin: 0 0 3px;
  color: var(--living-text-muted) !important;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  text-transform: none;
  letter-spacing: 0.035em;
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text p,
.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text a {
  max-width: 100%;
  margin: 0 !important;
  color: var(--living-text) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1.32;
  white-space: normal;
  overflow-wrap: anywhere;
}

.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text a:hover {
  color: var(--living-gold-soft) !important;
}

.maderas-elegant.home-3 .living-content-column {
  position: relative;
  grid-area: content;
  min-width: 0;
  align-self: center;
}

.maderas-elegant.home-3 .living-profile-column,
.maderas-elegant.home-3 .living-content-column {
  margin-top: clamp(28px, 3.2vw, 48px);
}

.maderas-elegant.home-3 .bostami-page-content-wrap {
  position: relative;
  min-height: 485px;
  overflow: hidden;
  color: var(--living-text);
  background: var(--living-glass) !important;
  border: 1px solid var(--living-border) !important;
  border-radius: 30px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.32), var(--living-shadow);
  backdrop-filter: blur(25px) saturate(120%);
  -webkit-backdrop-filter: blur(25px) saturate(120%);
  animation: living-panel-in 420ms ease both;
}

.maderas-elegant.home-3 .bostami-page-content-wrap::before {
  height: 48%;
  opacity: 0.7;
  background: radial-gradient(circle at 8% 0%, rgba(255, 255, 255, 0.15), transparent 28%), linear-gradient(120deg, rgba(255, 255, 255, 0.08), transparent 34%);
}

.maderas-elegant.home-3 .living-about-panel {
  min-height: 255px;
}

.maderas-elegant.home-3 .living-about-section {
  position: relative;
  z-index: 1;
  padding: clamp(34px, 4vw, 52px) clamp(30px, 4.4vw, 58px) 28px;
}

.maderas-elegant.home-3 .living-section-heading {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-bottom: 18px;
}

.maderas-elegant.home-3 .living-section-heading > span {
  width: clamp(74px, 12vw, 130px);
  height: 1px;
  background: linear-gradient(90deg, var(--living-gold), rgba(216, 185, 120, 0.15));
}

.maderas-elegant.home-3 .page-title,
.maderas-elegant.home-3 .section-title {
  margin: 0;
  color: var(--living-text) !important;
  font-family: "Roboto Slab", serif;
  font-weight: 400;
  text-transform: none;
}

.maderas-elegant.home-3 .page-title {
  font-size: clamp(34px, 3.5vw, 44px);
  line-height: 1.05;
  letter-spacing: -0.025em;
}

.maderas-elegant.home-3 .section-title {
  font-size: clamp(25px, 2.5vw, 31px);
  line-height: 1.1;
}

.maderas-elegant.home-3 .page-title::after,
.maderas-elegant.home-3 .bostami-page-title-wrap::after {
  display: none;
}

.maderas-elegant.home-3 .bostami-page-title-wrap p,
.maderas-elegant.home-3 .section-wrapper p {
  max-width: 720px;
  margin: 0 0 10px;
  color: var(--living-text) !important;
  font-size: clamp(14px, 1.25vw, 16px);
  font-weight: 400;
  line-height: 1.75;
  opacity: 0.92;
}

.maderas-elegant.home-3 .living-content-column > .bostami-page-content-wrap {
  width: 100%;
}

.maderas-elegant.home-3 .living-content-column .section-wrapper:not(.living-about-section) {
  padding-right: clamp(28px, 4vw, 54px) !important;
  padding-left: clamp(28px, 4vw, 54px) !important;
}

.maderas-elegant.home-3 .living-content-column .section-wrapper.pt-60 {
  padding-top: clamp(34px, 4vw, 50px) !important;
}

.maderas-elegant.home-3 .contact-area {
  padding: 10px 0 0;
}

.maderas-elegant.home-3 .form-input-item label {
  color: var(--living-text-soft) !important;
}

.maderas-elegant.home-3 .form-input-item .input-box {
  color: var(--living-text) !important;
  background: rgba(199, 220, 237, 0.1) !important;
  border: 1px solid var(--living-border-soft) !important;
  border-radius: 15px !important;
}

.maderas-elegant.home-3 .form-input-item .input-box:focus {
  background: rgba(210, 228, 242, 0.15) !important;
  border-color: rgba(240, 217, 157, 0.72) !important;
  box-shadow: 0 0 0 3px rgba(216, 185, 120, 0.12) !important;
}

.maderas-elegant.home-3 .form-btn {
  color: #122436 !important;
  background: linear-gradient(135deg, var(--living-gold-soft), var(--living-gold)) !important;
  animation: none !important;
}

.maderas-elegant.home-3 .form-btn:disabled {
  cursor: wait;
  opacity: 0.68;
  transform: none !important;
}

.maderas-elegant.home-3 .fillter-btn,
.maderas-elegant.home-3 .fillter-item {
  background: rgba(192, 215, 233, 0.1) !important;
  border-color: var(--living-border-soft) !important;
}

.maderas-elegant.home-3 .fillter-btn {
  color: var(--living-text-soft) !important;
}

.maderas-elegant.home-3 .fillter-btn:hover,
.maderas-elegant.home-3 .fillter-btn.is-checked {
  color: #122436 !important;
  background: linear-gradient(135deg, var(--living-gold-soft), var(--living-gold)) !important;
}

.maderas-elegant.home-3 .fillter-item .item-title {
  color: var(--living-text) !important;
}

.maderas-elegant.home-3 .fillter-item .item-subtitle {
  color: var(--living-text-muted) !important;
}

.maderas-elegant.home-3 .development-card-trigger {
  display: block;
  width: 100%;
  padding: 0;
  color: inherit;
  text-align: left;
  background: transparent;
  border: 0;
}

.maderas-elegant.home-3 .development-card-trigger .img img {
  display: block;
  width: 100%;
  height: auto;
}

.maderas-elegant.home-3 .development-card-trigger .item-title {
  display: block;
}

/* Development modal */
.maderas-elegant.home-3 .development-modal {
  position: fixed;
  inset: 0;
  z-index: 1090;
  display: grid !important;
  place-items: center;
  width: 100%;
  height: 100%;
  padding: clamp(14px, 3vw, 34px);
  overflow: hidden;
  background: rgba(2, 12, 23, 0.74);
  backdrop-filter: blur(10px) saturate(115%);
  -webkit-backdrop-filter: blur(10px) saturate(115%);
  animation: living-modal-backdrop-in 220ms ease both;
}

.maderas-elegant.home-3 .development-modal .modal-dialog {
  width: min(860px, 100%);
  max-width: 860px;
  max-height: calc(100dvh - clamp(28px, 6vw, 68px));
  margin: 0;
  animation: living-modal-card-in 320ms ease both;
}

.maderas-elegant.home-3 .development-modal .modal-content {
  max-height: inherit;
  overflow: hidden;
  color: var(--living-text);
  background: var(--living-glass-strong);
  border: 1px solid var(--living-border);
  border-radius: 30px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 34px 90px rgba(0, 8, 20, 0.52);
  backdrop-filter: blur(28px) saturate(125%);
  -webkit-backdrop-filter: blur(28px) saturate(125%);
}

.maderas-elegant.home-3 .development-modal .modal-body {
  padding: clamp(22px, 3.5vw, 34px);
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: var(--living-gold) rgba(223, 236, 247, 0.12);
  scrollbar-width: thin;
}

.maderas-elegant.home-3 .development-modal .modal-body::-webkit-scrollbar {
  width: 7px;
}

.maderas-elegant.home-3 .development-modal .modal-body::-webkit-scrollbar-track {
  background: rgba(223, 236, 247, 0.12);
  border-radius: 10px;
}

.maderas-elegant.home-3 .development-modal .modal-body::-webkit-scrollbar-thumb {
  background: var(--living-gold);
  border-radius: 10px;
}

.maderas-elegant.home-3 .development-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  padding: 0;
  color: var(--living-text);
  background: var(--theme-card-bg);
  border: 1px solid var(--living-border);
  border-radius: 50%;
  box-shadow: 0 8px 24px rgba(0, 8, 20, 0.3);
  transition: color 180ms ease, background 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.maderas-elegant.home-3 .development-modal__close:hover {
  color: #122436;
  background: var(--living-gold-soft);
  border-color: var(--living-gold-soft);
  transform: rotate(90deg);
}

.maderas-elegant.home-3 .development-modal__image {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16/5;
  margin-bottom: clamp(24px, 3vw, 32px);
  border: 1px solid var(--living-border-soft);
  border-radius: 20px;
  box-shadow: 0 16px 34px rgba(0, 8, 20, 0.24);
}

.maderas-elegant.home-3 .development-modal__image::after {
  position: absolute;
  inset: 0;
  content: "";
  pointer-events: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}

.maderas-elegant.home-3 .development-modal__image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.maderas-elegant.home-3 .development-modal__details {
  padding: 0 clamp(2px, 1vw, 8px) 2px;
}

.maderas-elegant.home-3 .development-modal__heading {
  padding-right: 42px;
  margin-bottom: 18px;
}

.maderas-elegant.home-3 .development-modal__heading > span {
  display: block;
  margin-bottom: 7px;
  color: var(--living-gold-soft);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.maderas-elegant.home-3 .development-modal__heading h2 {
  margin: 0;
  color: var(--living-text);
  font-family: "Roboto Slab", serif;
  font-size: clamp(26px, 3vw, 34px);
  font-weight: 400;
  line-height: 1.16;
}

.maderas-elegant.home-3 .development-modal__description {
  margin-bottom: 26px;
  color: var(--living-text-soft);
  font-size: 15px;
  line-height: 1.75;
  overflow-wrap: anywhere;
}

.maderas-elegant.home-3 .development-modal__description > :last-child {
  margin-bottom: 0;
}

.maderas-elegant.home-3 .development-modal__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.maderas-elegant.home-3 .development-modal__actions:empty {
  display: none;
}

.maderas-elegant.home-3 .development-modal__actions :is(a, button) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 11px 20px;
  color: var(--living-text);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  background: rgba(192, 215, 233, 0.1);
  border: 1px solid var(--living-border-soft);
  border-radius: 14px;
  transition: color 180ms ease, background 180ms ease, border-color 180ms ease, transform 180ms ease, box-shadow 180ms ease;
}

.maderas-elegant.home-3 .development-modal__actions :is(a, button) i {
  margin-right: 10px;
  color: var(--living-gold-soft);
  font-size: 16px;
}

.maderas-elegant.home-3 .development-modal__actions :is(a, button):hover {
  color: #122436;
  background: linear-gradient(135deg, var(--living-gold-soft), var(--living-gold));
  border-color: transparent;
  box-shadow: 0 10px 24px rgba(0, 8, 20, 0.2);
  transform: translateY(-2px);
}

.maderas-elegant.home-3 .development-modal__actions :is(a, button):hover i {
  color: #122436;
}

@keyframes living-modal-backdrop-in {
  from {
    opacity: 0;
  }
}
@keyframes living-modal-card-in {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.98);
  }
}
@media (max-width: 575px) {
  .maderas-elegant.home-3 .development-modal {
    padding: 12px;
  }
  .maderas-elegant.home-3 .development-modal .modal-dialog {
    max-height: calc(100dvh - 24px);
  }
  .maderas-elegant.home-3 .development-modal .modal-content {
    border-radius: 22px;
  }
  .maderas-elegant.home-3 .development-modal .modal-body {
    padding: 16px;
  }
  .maderas-elegant.home-3 .development-modal__close {
    top: 10px;
    right: 10px;
    width: 38px;
    height: 38px;
  }
  .maderas-elegant.home-3 .development-modal__image {
    aspect-ratio: 16/7;
    margin-bottom: 22px;
    border-radius: 15px;
  }
  .maderas-elegant.home-3 .development-modal__heading {
    padding-right: 0;
  }
  .maderas-elegant.home-3 .development-modal__description {
    margin-bottom: 22px;
    font-size: 14px;
    line-height: 1.65;
  }
  .maderas-elegant.home-3 .development-modal__actions {
    flex-direction: column;
  }
  .maderas-elegant.home-3 .development-modal__actions :is(a, button) {
    width: 100%;
  }
}
.maderas-elegant.home-3 .footer-copyright {
  color: var(--living-text-muted) !important;
  background: rgba(3, 16, 30, 0.1) !important;
  border-color: var(--living-border-soft) !important;
}

.maderas-elegant.home-3 .elegant-curve-bg,
.maderas-elegant.home-3 .elegant-curve-bg-2 {
  position: absolute;
  z-index: 4;
  width: 68px;
  height: 68px;
  pointer-events: none;
  background: radial-gradient(circle at 32% 26%, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.12) 18%, rgba(97, 142, 178, 0.2) 42%, rgba(6, 27, 46, 0.22) 72%);
  border: 1px solid rgba(231, 241, 249, 0.46);
  border-radius: 50%;
  box-shadow: inset -10px -12px 22px rgba(2, 16, 31, 0.24), inset 8px 7px 16px rgba(255, 255, 255, 0.12), 0 12px 30px rgba(0, 8, 20, 0.28);
  opacity: 0.74;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.maderas-elegant.home-3 .elegant-curve-bg {
  top: -26px;
  right: auto;
  left: -28px;
  transform: none;
}

.maderas-elegant.home-3 .elegant-curve-bg-2 {
  top: auto;
  right: -28px;
  bottom: -28px;
  left: auto;
  transform: none;
}

.maderas-elegant.home-3 :is(a, button):focus-visible {
  outline: 2px solid var(--living-gold-soft);
  outline-offset: 3px;
}

@keyframes living-panel-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .maderas-elegant.home-3 {
    padding-top: 20px;
  }
  .maderas-elegant.home-3 .living-dashboard {
    grid-template-columns: minmax(286px, 318px) minmax(0, 1fr);
    column-gap: 24px;
    width: min(100% - 30px, 1140px);
  }
  .maderas-elegant.home-3 .living-brand-lockup {
    padding: 10px 16px;
  }
  .maderas-elegant.home-3 .living-brand-mark {
    margin-right: -34px;
  }
  .maderas-elegant.home-3 .living-brand-script {
    font-size: 27px;
  }
  .maderas-elegant.home-3 .living-brand-copy strong {
    font-size: 17px;
  }
  .maderas-elegant.home-3 .bastami-main-menu .menu-item-content {
    padding: 9px 10px;
  }
  .maderas-elegant.home-3 .menu-item-content .icon {
    margin-right: 6px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-area {
    padding: 22px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-img img {
    width: 220px;
    height: 220px;
  }
  .maderas-elegant.home-3 .living-loading-photo {
    width: 220px;
    height: 220px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-name {
    font-size: 25px;
  }
}
@media (min-width: 992px) and (max-height: 820px) {
  .maderas-elegant.home-3 {
    padding: 14px 0 24px;
  }
  .maderas-elegant.home-3 .living-dashboard {
    row-gap: 14px;
    min-height: calc(100vh - 38px);
  }
  .maderas-elegant.home-3 .living-profile-column,
  .maderas-elegant.home-3 .living-content-column {
    margin-top: 20px;
  }
  .maderas-elegant.home-3 .living-brand-lockup {
    min-height: 72px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .maderas-elegant.home-3 .bastami-main-menu .menu-item-content {
    min-height: 50px;
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-area {
    padding: 19px 22px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-img {
    margin-bottom: 12px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-img img {
    width: 205px;
    height: 205px;
    border-radius: 25px !important;
  }
  .maderas-elegant.home-3 .living-loading-profile {
    min-height: 0;
  }
  .maderas-elegant.home-3 .living-loading-photo {
    width: 205px;
    height: 205px;
    margin-bottom: 12px;
    border-radius: 25px;
  }
  .maderas-elegant.home-3 .living-loading-name {
    height: 26px;
    margin-bottom: 7px;
  }
  .maderas-elegant.home-3 .living-loading-badge {
    height: 27px;
    margin-bottom: 10px;
  }
  .maderas-elegant.home-3 .living-loading-socials {
    min-height: 38px;
    margin-bottom: 11px;
  }
  .maderas-elegant.home-3 .living-loading-socials > span {
    width: 38px;
    height: 38px;
  }
  .maderas-elegant.home-3 .living-loading-heading {
    height: 18px;
    margin-bottom: 7px;
  }
  .maderas-elegant.home-3 .living-loading-contact {
    min-height: 53px;
    margin-bottom: 7px;
    padding: 7px 10px;
  }
  .maderas-elegant.home-3 .living-loading-contact__icon {
    flex-basis: 36px;
    width: 36px;
    height: 36px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-name {
    margin-bottom: 7px;
    font-size: 24px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-bio {
    min-height: 27px;
    margin-bottom: 10px;
    padding: 4px 16px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-social-link {
    min-height: 38px;
    margin-bottom: 11px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-social-link li a {
    width: 38px;
    height: 38px;
  }
  .maderas-elegant.home-3 .living-contact-heading {
    margin-bottom: 7px;
    font-size: 16px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-contact-item {
    min-height: 53px;
    margin-bottom: 7px;
    padding: 7px 10px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-contact-item .icon {
    flex-basis: 36px;
    width: 36px;
    height: 36px;
    min-width: 36px;
  }
  .maderas-elegant.home-3 .bostami-page-content-wrap {
    min-height: 430px;
  }
  .maderas-elegant.home-3 .living-loading-content__card {
    min-height: 430px;
    padding-top: 30px;
    padding-bottom: 24px;
  }
  .maderas-elegant.home-3 .living-about-section {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .maderas-elegant.home-3 .living-section-heading {
    margin-bottom: 12px;
  }
  .maderas-elegant.home-3 .page-title {
    font-size: 36px;
  }
  .maderas-elegant.home-3 .bostami-page-title-wrap p,
  .maderas-elegant.home-3 .section-wrapper p {
    margin-bottom: 7px;
    font-size: 14px;
    line-height: 1.58;
  }
  .maderas-elegant.home-3 .section-title {
    font-size: 26px;
  }
  .maderas-elegant.home-3 .living-about-panel {
    min-height: 235px;
  }
}
@media (max-width: 991px) {
  .maderas-elegant.home-3 {
    height: auto;
    min-height: 100vh;
    padding: 20px 0 34px;
    overflow-y: visible;
    background-attachment: scroll;
  }
  .maderas-elegant.home-3 .living-dashboard {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "brand" "navigation" "profile" "content";
    gap: 18px;
    width: min(100% - 30px, 720px);
    min-height: auto;
  }
  .maderas-elegant.home-3 .living-brand-bar,
  .maderas-elegant.home-3 .living-navigation,
  .maderas-elegant.home-3 .living-profile-column,
  .maderas-elegant.home-3 .living-content-column {
    width: 100%;
  }
  .maderas-elegant.home-3 .living-brand-lockup {
    padding-right: 76px;
  }
  .maderas-elegant.home-3 .theme-toggle-btn {
    right: 14px;
  }
  .maderas-elegant.home-3 .living-profile-column,
  .maderas-elegant.home-3 .living-content-column {
    margin-top: 0;
  }
  .maderas-elegant.home-3 .living-navigation {
    justify-self: stretch;
  }
  .maderas-elegant.home-3 .bostami-main-menu-wrap {
    width: 100% !important;
    margin: 0 !important;
  }
  .maderas-elegant.home-3 .bastami-main-menu ul {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    padding: 0;
  }
  .maderas-elegant.home-3 .bastami-main-menu ul li {
    width: auto !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .maderas-elegant.home-3 .bastami-main-menu .menu-item-content {
    flex-direction: row;
    min-height: 54px;
  }
  .maderas-elegant.home-3 .menu-item-content .icon {
    margin: 0 7px 0 0 !important;
    font-size: 18px !important;
  }
  .maderas-elegant.home-3 .menu-item-content .text {
    font-size: 13px !important;
    text-transform: none;
  }
  .maderas-elegant.home-3 .living-profile-column {
    max-width: 540px;
    margin: 0 auto;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-img img {
    height: 258px;
  }
  .maderas-elegant.home-3 .living-loading-photo {
    width: 258px;
    height: 258px;
  }
  .maderas-elegant.home-3 .elegant-curve-bg {
    top: -22px;
    left: -18px;
  }
  .maderas-elegant.home-3 .elegant-curve-bg-2 {
    right: -18px;
    bottom: -22px;
  }
}
@media (max-width: 575px) {
  .maderas-elegant.home-3 {
    padding-top: 14px;
  }
  .maderas-elegant.home-3 .living-dashboard {
    gap: 14px;
    width: min(100% - 22px, 540px);
  }
  .maderas-elegant.home-3 .elegant-curve-bg,
  .maderas-elegant.home-3 .elegant-curve-bg-2 {
    width: 56px;
    height: 56px;
  }
  .maderas-elegant.home-3 .living-brand-lockup {
    min-height: 72px;
    padding: 8px 66px 8px 14px;
    border-radius: 20px;
  }
  .maderas-elegant.home-3 .living-brand-mark {
    flex-basis: 50px;
    width: 50px;
    height: 44px;
    margin-right: -30px;
  }
  .maderas-elegant.home-3 .living-brand-mark::before {
    top: 8px;
    left: 10px;
    width: 29px;
    height: 29px;
  }
  .maderas-elegant.home-3 .living-brand-mark::after {
    height: 23px;
  }
  .maderas-elegant.home-3 .living-brand-script {
    margin-right: 5px;
    font-size: 24px;
  }
  .maderas-elegant.home-3 .living-brand-copy strong {
    font-size: 15px;
  }
  .maderas-elegant.home-3 .theme-toggle-btn {
    right: 10px;
    width: 44px;
    height: 44px;
  }
  .maderas-elegant.home-3 .bostami-main-menu-wrap {
    padding: 5px;
    border-radius: 19px;
  }
  .maderas-elegant.home-3 .bastami-main-menu .menu-item-content {
    flex-direction: column;
    min-height: 68px;
    padding: 7px 3px;
  }
  .maderas-elegant.home-3 .menu-item-content .icon {
    width: 28px;
    height: 28px;
    margin: 0 0 4px !important;
    border-radius: 9px;
    font-size: 15px !important;
  }
  .maderas-elegant.home-3 .menu-item-content .text {
    max-width: 100%;
    overflow: hidden;
    font-size: 10px !important;
    text-overflow: ellipsis;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-area {
    padding: 22px 18px;
    border-radius: 25px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-img img {
    width: min(100%, 240px);
    height: 240px;
    border-radius: 26px !important;
  }
  .maderas-elegant.home-3 .living-loading-photo {
    width: min(100%, 240px);
    height: 240px;
    border-radius: 26px;
  }
  .maderas-elegant.home-3 .living-loading-content__card {
    min-height: 420px;
    padding: 30px 22px 24px;
  }
  .maderas-elegant.home-3 .living-loading-title {
    height: 36px;
  }
  .maderas-elegant.home-3 .bostami-parsonal-info-name {
    font-size: 25px;
  }
  .maderas-elegant.home-3 .living-about-section {
    padding: 30px 22px 24px;
  }
  .maderas-elegant.home-3 .living-section-heading {
    gap: 14px;
  }
  .maderas-elegant.home-3 .living-section-heading > span {
    min-width: 38px;
  }
  .maderas-elegant.home-3 .page-title {
    font-size: 34px;
  }
  .maderas-elegant.home-3 .section-title {
    font-size: 23px;
  }
  .maderas-elegant.home-3 .living-content-column .section-wrapper:not(.living-about-section) {
    padding-right: 22px !important;
    padding-left: 22px !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .maderas-elegant.home-3 *,
  .maderas-elegant.home-3 *::before,
  .maderas-elegant.home-3 *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
/* Living Maderas QR view */
.maderas-elegant.qr-view-container {
  --living-gold: #d8b978;
  --living-gold-soft: #f0d99d;
  --living-text: #f8fbff;
  --living-text-soft: rgba(234, 242, 250, 0.78);
  --living-text-muted: rgba(224, 234, 244, 0.58);
  --living-glass: linear-gradient(
    150deg,
    rgba(44, 67, 91, 0.76) 0%,
    rgba(8, 26, 45, 0.7) 58%,
    rgba(5, 18, 33, 0.78) 100%
  );
  --living-glass-soft: rgba(164, 191, 216, 0.1);
  --living-border: rgba(227, 239, 250, 0.38);
  --living-border-soft: rgba(227, 239, 250, 0.17);
  --living-shadow: 0 28px 70px rgba(0, 8, 20, 0.42);
  display: block !important;
  min-height: 100vh !important;
  padding: 42px 18px 34px !important;
  overflow-x: hidden;
  overflow-y: auto;
  background-attachment: fixed;
  isolation: isolate;
}

.maderas-elegant.qr-view-container.light-theme {
  --living-text: #11263b;
  --living-text-soft: rgba(17, 38, 59, 0.78);
  --living-text-muted: rgba(17, 38, 59, 0.6);
  --living-glass: linear-gradient(
    150deg,
    rgba(255, 255, 255, 0.88) 0%,
    rgba(229, 240, 249, 0.78) 58%,
    rgba(213, 229, 241, 0.82) 100%
  );
  --living-glass-soft: rgba(255, 255, 255, 0.42);
  --living-border: rgba(255, 255, 255, 0.72);
  --living-border-soft: rgba(255, 255, 255, 0.48);
  --living-shadow: 0 26px 66px rgba(6, 27, 47, 0.25);
}

.maderas-elegant.qr-view-container .living-background-overlay {
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(1, 12, 27, 0.62) 0%, rgba(4, 18, 34, 0.3) 48%, rgba(2, 14, 29, 0.4) 100%), linear-gradient(180deg, rgba(2, 13, 27, 0.16) 0%, transparent 44%, rgba(1, 10, 22, 0.48) 100%);
}

.maderas-elegant.qr-view-container.light-theme .living-background-overlay {
  background: linear-gradient(90deg, rgba(9, 27, 47, 0.36) 0%, rgba(16, 37, 57, 0.12) 48%, rgba(7, 23, 40, 0.22) 100%), linear-gradient(180deg, rgba(209, 228, 242, 0.08) 0%, transparent 50%, rgba(3, 17, 32, 0.26) 100%);
}

.maderas-elegant.qr-view-container .qr-content-wrapper {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 430px);
  max-width: 430px;
  margin: 0 auto;
}

.maderas-elegant.qr-view-container .living-brand-bar {
  position: relative;
  z-index: 5;
  width: 100%;
}

.maderas-elegant.qr-view-container .living-brand-lockup {
  padding-right: 84px;
}

.maderas-elegant.qr-view-container .theme-toggle-btn {
  position: absolute;
  top: 50%;
  right: 18px;
  z-index: 6;
  width: 48px;
  height: 48px;
  color: var(--living-gold-soft);
  background: rgba(9, 28, 48, 0.68);
  border: 1px solid var(--living-border);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18), 0 12px 26px rgba(0, 8, 20, 0.28);
  transform: translateY(-50%);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.maderas-elegant.qr-view-container .theme-toggle-btn:hover {
  transform: translateY(-50%) scale(1.06);
}

.maderas-elegant.qr-view-container :is(a, button):focus-visible {
  outline: 2px solid var(--living-gold-soft);
  outline-offset: 3px;
}

.maderas-elegant.qr-view-container.light-theme .theme-toggle-btn {
  color: #8e6d31;
  background: rgba(241, 248, 253, 0.76);
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-area {
  position: relative;
  width: 100% !important;
  max-width: none !important;
  margin: 102px 0 0 !important;
  padding: 112px 30px 30px;
  overflow: visible;
  color: var(--living-text);
  background: var(--living-glass) !important;
  border: 1px solid var(--living-border) !important;
  border-radius: 30px;
  box-shadow: -22px 18px 48px rgba(2, 12, 23, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.22), var(--living-shadow);
  backdrop-filter: blur(24px) saturate(120%);
  -webkit-backdrop-filter: blur(24px) saturate(120%);
  isolation: isolate;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-area::before {
  position: absolute;
  inset: 14px auto 14px -18px;
  z-index: -1;
  width: 45px;
  content: "";
  background: linear-gradient(180deg, rgba(168, 199, 225, 0.2), rgba(5, 18, 33, 0.06));
  border-radius: 28px 0 0 28px;
  filter: blur(8px);
  opacity: 0.72;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-area::after {
  position: absolute;
  top: 0;
  left: 32px;
  width: 46%;
  height: 2px;
  content: "";
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.9), var(--living-gold-soft), transparent);
  filter: blur(0.2px);
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-wrap {
  position: relative;
  z-index: 2;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-img {
  position: absolute !important;
  top: -198px;
  left: 50%;
  margin: 0 !important;
  transform: translateX(-50%);
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-img img {
  display: block;
  width: 172px !important;
  height: 172px !important;
  padding: 4px;
  object-fit: cover;
  background: rgba(10, 28, 47, 0.64) !important;
  border: 1px solid var(--living-gold-soft) !important;
  border-radius: 28px !important;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.42), 0 14px 32px rgba(0, 8, 20, 0.36), 0 0 20px rgba(216, 185, 120, 0.22);
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-name {
  max-width: 340px;
  margin: 0 auto 10px !important;
  color: var(--living-text) !important;
  font-family: "Roboto Slab", serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 1.12;
  text-transform: none;
  letter-spacing: 0;
  text-wrap: balance;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-name span {
  color: inherit !important;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-bio {
  display: table;
  margin: 0 auto 22px;
  padding: 5px 22px;
  color: var(--living-text) !important;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  text-transform: none;
  letter-spacing: 0;
  background: linear-gradient(135deg, rgba(240, 217, 157, 0.78), rgba(142, 109, 49, 0.72)) !important;
  border: 1px solid rgba(240, 217, 157, 0.5);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.maderas-elegant.qr-view-container .qr-code-container {
  display: grid;
  width: min(100%, 250px);
  margin: 0 auto 24px;
  padding: 20px;
  place-items: center;
  background: linear-gradient(145deg, rgba(169, 193, 214, 0.12), rgba(3, 17, 31, 0.26));
  border: 1px solid rgba(216, 185, 120, 0.5);
  border-radius: 22px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14), 0 14px 32px rgba(0, 8, 20, 0.2), 0 0 24px rgba(216, 185, 120, 0.1);
}

.maderas-elegant.qr-view-container.light-theme .qr-code-container {
  background: rgba(255, 255, 255, 0.42);
}

.maderas-elegant.qr-view-container .qr-code-canvas {
  display: block;
  width: 100%;
  height: auto;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact {
  width: 100% !important;
  padding: 0 !important;
  background: transparent !important;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item {
  min-height: 62px;
  margin: 0 0 10px;
  padding: 9px 11px !important;
  gap: 12px;
  text-align: left;
  background: linear-gradient(135deg, rgba(180, 205, 226, 0.13), rgba(4, 18, 33, 0.14)) !important;
  border: 1px solid var(--living-border-soft);
  border-radius: 16px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item:last-child {
  margin-bottom: 0;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .icon {
  display: grid;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  min-width: 42px;
  place-items: center;
  background: linear-gradient(145deg, rgba(222, 231, 239, 0.26), rgba(112, 137, 161, 0.16)) !important;
  border: 1px solid var(--living-border-soft);
  border-radius: 13px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24);
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .icon i {
  color: var(--living-gold-soft) !important;
  font-size: 17px;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .text {
  flex: 1 1;
  min-width: 0;
  align-items: flex-start;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .text span {
  margin: 0 0 3px;
  color: var(--living-text-muted) !important;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  text-transform: none;
  letter-spacing: 0.035em;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .text a {
  max-width: 100%;
  margin: 0 !important;
  color: var(--living-text) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1.35;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: normal !important;
}

.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .text a:hover {
  color: var(--living-gold-soft) !important;
}

.maderas-elegant.qr-view-container .elegant-curve-bg,
.maderas-elegant.qr-view-container .elegant-curve-bg-2 {
  position: absolute;
  z-index: 4;
  width: 64px;
  height: 64px;
  pointer-events: none;
  background: radial-gradient(circle at 32% 26%, rgba(255, 255, 255, 0.72), rgba(255, 255, 255, 0.12) 18%, rgba(97, 142, 178, 0.2) 42%, rgba(6, 27, 46, 0.22) 72%);
  border: 1px solid rgba(231, 241, 249, 0.46);
  border-radius: 50%;
  box-shadow: inset -10px -12px 22px rgba(2, 16, 31, 0.24), inset 8px 7px 16px rgba(255, 255, 255, 0.12), 0 12px 30px rgba(0, 8, 20, 0.28);
  opacity: 0.76;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.maderas-elegant.qr-view-container .elegant-curve-bg {
  top: -24px;
  right: auto;
  left: -26px;
  transform: none;
}

.maderas-elegant.qr-view-container .elegant-curve-bg-2 {
  top: auto;
  right: -26px;
  bottom: -26px;
  left: auto;
  transform: none;
}

@media (max-width: 575px) {
  .maderas-elegant.qr-view-container {
    padding: 34px 11px 26px !important;
    background-attachment: scroll;
  }
  .maderas-elegant.qr-view-container .qr-content-wrapper {
    width: min(100%, 390px);
  }
  .maderas-elegant.qr-view-container .theme-toggle-btn {
    width: 44px;
    height: 44px;
  }
  .maderas-elegant.qr-view-container .bostami-parsonal-info-area {
    margin-top: 94px !important;
    padding: 102px 18px 20px;
    border-radius: 26px;
  }
  .maderas-elegant.qr-view-container .bostami-parsonal-info-img {
    top: -180px;
  }
  .maderas-elegant.qr-view-container .bostami-parsonal-info-img img {
    width: 158px !important;
    height: 158px !important;
    border-radius: 25px !important;
  }
  .maderas-elegant.qr-view-container .bostami-parsonal-info-name {
    font-size: clamp(23px, 7.4vw, 27px);
  }
  .maderas-elegant.qr-view-container .qr-code-container {
    width: min(100%, 226px);
    padding: 16px;
  }
  .maderas-elegant.qr-view-container .elegant-curve-bg,
  .maderas-elegant.qr-view-container .elegant-curve-bg-2 {
    width: 56px;
    height: 56px;
  }
  .maderas-elegant.qr-view-container .elegant-curve-bg {
    top: -20px;
    left: -18px;
  }
  .maderas-elegant.qr-view-container .elegant-curve-bg-2 {
    right: -18px;
    bottom: -20px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .maderas-elegant.qr-view-container *,
  .maderas-elegant.qr-view-container *::before,
  .maderas-elegant.qr-view-container *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/elegant-maderas.scss"],"names":[],"mappings":"AAAA,oCAAA;AAEA;EACE,wBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA;;;;;GAAA;EAOA,iCAAA;EACA,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,wCAAA;EACA,6CAAA;EACA,2CAAA;EACA,kDAAA;EACA,8CAAA;EACA,gDAAA;AADF;;AAIA,0BAAA;AACA;EACE,mBAAA;EACA,wBAAA;EACA,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,0CAAA;EACA,6CAAA;EACA,qCAAA;EACA,4CAAA;EACA,8CAAA;EACA,0CAAA;AADF;;AAIA;EACE,4CAAA;EACA,4DAAA;EACA,kCAAA;EACA,4BAAA;EACA,sBAAA;EACA,2CAAA;EACA,kCAAA;EACA,iBAAA;EACA,uDACE;AAFJ;;AAMA,uBAAA;AACA;EACE,iBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kCAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AAHF;;AAMA;EACE,iCAAA;EACA,2CAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yCAAA;AAHF;;AAMA;EACE,qBAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;EACA,8BAAA;EACA,YAAA;EACA,+CAAA;AAHF;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AAHF;;AAMA;EACE,yBAAA;EACA,eAAA;EACA,YAAA;AAHF;;AAMA,mDAAA;AACA;EACE;IACE,2BAAA;EAHF;EAKA;IACE,6BAAA;EAHF;EAKA;IACE,2BAAA;EAHF;AACF;AAMA;;EAEE,qCAAA;EACA,4CAAA;AAJF;;AAOA,uBAAA;AACA;EACE,2CAAA,EAAA,2BAAA;EACA,uDAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AAJF;;AAOA;EACE,gDAAA;EACA,aAAA;EACA,8BAAA;EACA,kCAAA;AAJF;;AAOA;EACE,2CAAA;EACA,iCAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,2CAAA,EAAA,oBAAA;EACA,+CAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;AAJF;;AAOA,sFAAA;AACA;EACE,kCAAA;EACA,qBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,+CAAA,EAAA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAJF;;AAOA;EACE,8CAAA,EAAA,2BAAA;EACA,WAAA,EAAA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,2CAAA;EACA,mCAAA;EACA,2CAAA;AAJF;;AAOA;EACE,2CAAA;EACA,eAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,YAAA,EAAA,8DAAA;AAJF;;AAOA;EACE,yCAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAOA;;EAEE,2CAAA;EACA,2BAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,iDAAA;EACA,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAJF;;AAOA;EACE,SAAA;AAJF;;AAOA,sBAAA;AACA;EACE,4CAAA;EACA,sDAAA;EACA,mBAAA;EACA,aAAA;AAJF;;AAOA;EACE,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,mDAAA;EACA,4CAAA;AAJF;;AAOA;EACE,iDAAA;EACA,2CAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,mDAAA;EACA,sBAAA;EACA,8CAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA,iBAAA;AACA;EACE,4CAAA;EACA,sDAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,kCAAA;AAJF;;AAOA;EACE,4CAAA;EACA,+CAAA;AAJF;;AAOA;;EAEE,iCAAA;EACA,2CAAA;EACA,gBAAA;AAJF;;AAOA;;EAEE,2CAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;EACA,gBAAA;AAJF;;AAOA,qCAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,wVACE;EAoBF,0BAAA;EACA,oBAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,uBAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,kCAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,2CAAA;EACA,eAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,4CAAA;EACA,sDAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,4CAAA;EACA,uDAAA;EACA,gDAAA;AAxBF;;AA2BA;EACE,mDAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yDAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,2BAAA;EACA,yDAAA;AAxBF;;AA2BA;EACE,0CAAA;EACA,0DAAA;EACA,yCAAA;AAxBF;;AA2BA,4BAAA;AACA;EACE,4CAAA;EACA,sDAAA;EACA,8BAAA;EACA,aAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,4CAAA;EACA,2BAAA;AAxBF;;AA2BA,sBAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA,EAAA,2CAAA;EACA,uBAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,4CAAA;EACA,sDAAA;EACA,6CAAA;EACA,4BAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAxBF;;AA2BA;;EAEE,mDAAA;EACA,sBAAA;EACA,oCAAA;AAxBF;;AA2BA;EACE,4CAAA;EACA,sDAAA;EACA,8BAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,2CAAA;EACA,gBAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,yCAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAxBF;;AA2BA,iDAAA;AACA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,UAAA,EAAA,6DAAA;AAxBF;;AA2BA,mDAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,UAAA;AAxBF;;AA2BA,6CAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,2EAAA;EACA,wBAAA;EACA,YAAA;AAxBF;;AA2BA,qCAAA;AACA;EACE;;IAEE,yBAAA;IACA,8BAAA;IACA,sBAAA;IACA,sBAAA;EAxBF;EA2BA;IACE,wBAAA;IACA,yCAAA;IACA,WAAA;IACA,cAAA;EAzBF;EA4BA;IACE,oCAAA;IACA,wBAAA;IACA,0BAAA;IACA,uBAAA;IACA,2BAAA;EA1BF;EA6BA;IACE,0BAAA;IACA,6BAAA;EA3BF;EA8BA;IACE,0BAAA;IACA,gBAAA;IACA,0BAAA;IACA,mBAAA;EA5BF;EA+BA,kFAAA;EACA;;IAEE,wBAAA;EA7BF;AACF;AAgCA,4BAAA;AACA;EACE,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,kCAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,UAAA;EACA,QAAA;AA9BF;;AAiCA;EACE,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,6BAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,2BAAA;AA9BF;;AAiCA;EACE,uBAAA;EACA,wBAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,4BAAA,EAAA,gDAAA;EACA,8BAAA;AA9BF;;AAiCA;EACE,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,oDAAA;AA9BF;;AAiCA;EACE,gBAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,sBAAA;EACA,yBAAA,EAAA,uCAAA;EACA,wCAAA,EAAA,sBAAA;AA9BF;;AAiCA;EACE,6BAAA;AA9BF;;AAiCA;EACE,8BAAA,EAAA,mBAAA;EACA,gCAAA;EACA,gBAAA;AA9BF;;AAiCA,sDAAA;AACA;;EAEE,YAAA;AA9BF;;AAiCA,yCAAA;AACA;EACE,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,6CAAA;EACA,8CAAA;EACA,gDAAA;EACA,sDAAA;EACA;;;;;GAAA;EAMA;;;;;GAAA;EAMA,6CAAA;EACA,0CAAA;EACA,+CAAA;EACA,iDAAA;EACA,sCAAA;EACA,6CAAA;EACA,wCAAA;EACA,+CAAA;EACA,4CAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;EACA,kDAAA;EACA,oCAAA;EACA,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,sBAAA;EACA,0CAAA;EACA,0CAAA;EACA,8CAAA;EACA,qDAAA;EACA;;;;;GAAA;EAMA;;;;GAAA;EAKA,8CAAA;EACA,yCAAA;EACA,+CAAA;EACA,kDAAA;EACA,0CAAA;EACA,8CAAA;EACA,wCAAA;EACA,+CAAA;EACA,4CAAA;EACA,0CAAA;EACA,0CAAA;EACA,2CAAA;EACA,kDAAA;EACA,oCAAA;EACA,gDAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,8OACE;AA/BJ;;AA8CA;EACE,wNACE;AA5CJ;;AA0DA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,0DAAA;EACA,yDACE;EAEF,oCAAA;EACA,aAAA;EACA,+BAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,gBAAA;EACA,yJACE;EAQF,2CAAA;EACA,4DAAA;AAjEF;;AAoEA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,sCAAA;EACA,mBAAA;EACA,qFACE;EAEF,0CAAA;EACA,kDAAA;AAnEF;;AAsEA;EACE,gBAAA;EACA,mBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAnEF;;AAsEA;EACE,uBAAA;EACA,iCAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AAnEF;;AAsEA;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,sBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,WAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;AAnEF;;AAsEA;EACE,gBAAA;AAnEF;;AAsEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;AAnEF;;AAsEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,iBAAA;EACA,wDAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,sCAAA;EACA,mBAAA;EACA,yEACE;EAEF,0CAAA;EACA,kDAAA;AArEF;;AAwEA;EACE,WAAA;AArEF;;AAwEA;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AArEF;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AArEF;;AAwEA;EACE,UAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,UAAA;AArEF;;AAwEA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;AArEF;;AAwEA;EACE,eAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;AArEF;;AAwEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,oCAAA;EACA,kBAAA;EACA,oDAAA;AArEF;;AAwEA;EACE,iBAAA;EACA,uBAAA;EACA,uCAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,sCAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EACA,0CAAA;EACA,kDAAA;AArEF;;AAwEA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oCAAA;EACA,sCAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,8BAAA;EACA,eAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sFAAA;EAKA,2CAAA;EACA,mBAAA;EACA,+CAAA;EACA,eAAA;EACA,uDACE;AA1EJ;;AA8EA;EACE,cAAA;EACA,+CAAA;EACA,2BAAA;AA3EF;;AA8EA;EACE;IACE,4BAAA;EA3EF;AACF;AA8EA;EACE;IACE,yBAAA;EA5EF;AACF;AA+EA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AA7EF;;AAgFA;;EAEE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,sCAAA;EACA,mBAAA;EACA,iJACE;EAIF,0CAAA;EACA,kDAAA;EACA,sFACE;AAlFJ;;AAuFA;;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,weACE;EA4BF,sDAAA;AAhHF;;AAmHA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,+EAAA;AAhHF;;AAuHA;;EAEE,yBAAA;EACA,uCAAA;EACA,2BAAA;AApHF;;AAuHA;;EAEE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;AApHF;;AAuHA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,yCAAA;EACA,wBAAA;AApHF;;AAuHA;;EAEE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,0CAAA;EACA,2CAAA;EACA,yCAAA;AApHF;;AAuHA;;EAEE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AApHF;;AAuHA;;EAEE,iBAAA;EACA,yBAAA;EACA,8CAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AApHF;;AAuHA;;EAEE,yBAAA;EACA,iCAAA;EACA,mCAAA;EACA,gBAAA;EACA,sBAAA;AApHF;;AAuHA;;EAEE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AApHF;;AAuHA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,sCAAA;EACA,sCAAA;EACA,qFACE;EAEF,2BAAA;EACA,2BAAA;EACA,mCAAA;AAtHF;;AAyHA;EACE,8BAAA;EACA,sCAAA;EACA,uCAAA;EACA,uCAAA;AAtHF;;AAyHA;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AAtHF;;AAyHA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,iDAAA;EACA,mBAAA;EACA,oFACE;EAEF,0CAAA;EACA,kDAAA;AAxHF;;AA2HA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AAxHF;;AA2HA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;AAxHF;;AA2HA;EACE,gDAAA;EACA,4BAAA;AAxHF;;AA2HA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,sGACE;AAzHJ;;AA+HA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;AA5HF;;AA+HA;EACE,eAAA;EACA,gBAAA;AA5HF;;AA+HA;EACE,kCAAA;AA5HF;;AA+HA;EAKE,yBAAA;EACA,qCAAA;AAhIF;;AAmIA;EACE,kCAAA;EACA,gBAAA;EACA,0BAAA;AAhIF;;AAmIA;EAKE,cAAA;EACA,sFAAA;EAKA,uFACE;AAzIJ;;AA6IA;EAME,8BAAA;EACA,qCAAA;EACA,uCAAA;AA/IF;;AAkJA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;AA/IF;;AAkJA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,iCAAA;EACA,gBAAA;EACA,iDAAA;EACA,iDAAA;EACA,mBAAA;EACA,qMACE;EAKF,0CAAA;EACA,kDAAA;AApJF;;AAuJA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,+EAAA;EAKA,yBAAA;AAxJF;;AA2JA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AAxJF;;AA2JA;EACE,aAAA;AAxJF;;AA2JA;EACE,mBAAA;AAxJF;;AA2JA;EACE,uBAAA;EACA,iCAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gDAAA;EACA,qDAAA;EACA,8BAAA;EACA,wHACE;AAzJJ;;AA8JA;EACE,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,iCAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AA3JF;;AA8JA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,kGAAA;EAKA,2CAAA;EACA,oBAAA;EACA,mDAAA;AA/JF;;AAkKA;EACE,yBAAA;AA/JF;;AAkKA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;AA/JF;;AAkKA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,gDAAA;EACA,2CAAA;EACA,kBAAA;EACA,mDAAA;EACA,wGACE;AAhKJ;;AAsKA;EACE,yCAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;AAnKF;;AAsKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AAnKF;;AAsKA;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mEAAA;AAnKF;;AAsKA;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,kCAAA;AAnKF;;AAsKA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,oGAAA;EAKA,2CAAA;EACA,mBAAA;EACA,kDAAA;AAvKF;;AA0KA;EAEE,gBAAA;AAxKF;;AA2KA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oGAAA;EAKA,2CAAA;EACA,mBAAA;EACA,mDAAA;AA5KF;;AA+KA;EACE,yCAAA;EACA,eAAA;AA5KF;;AA+KA;EACE,SAAA;EACA,YAAA;EACA,uBAAA;AA5KF;;AA+KA;EACE,eAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;AA5KF;;AA+KA;;EAEE,eAAA;EACA,oBAAA;EACA,oCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AA5KF;;AA+KA;EAIE,yCAAA;AA/KF;;AAkLA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AA/KF;;AAkLA;;EAEE,oCAAA;AA/KF;;AAkLA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,iDAAA;EACA,mBAAA;EACA,yEACE;EAEF,0CAAA;EACA,kDAAA;EACA,0CAAA;AAjLF;;AAoLA;EACE,WAAA;EACA,YAAA;EACA,6JACE;AAlLJ;;AA8LA;EACE,iBAAA;AA3LF;;AA8LA;EACE,kBAAA;EACA,UAAA;EACA,6DAAA;AA3LF;;AA8LA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA3LF;;AA8LA;EACE,+BAAA;EACA,WAAA;EACA,iFAAA;AA3LF;;AAkMA;;EAEE,SAAA;EACA,oCAAA;EACA,iCAAA;EACA,gBAAA;EACA,oBAAA;AA/LF;;AAkMA;EACE,mCAAA;EACA,iBAAA;EACA,wBAAA;AA/LF;;AAkMA;EACE,mCAAA;EACA,gBAAA;AA/LF;;AAkMA;;EAEE,aAAA;AA/LF;;AAkMA;;EAEE,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;AA/LF;;AAkMA;EACE,WAAA;AA/LF;;AAkMA;EAGE,gDAAA;EACA,+CAAA;AAjMF;;AAoMA;EAGE,8CAAA;AAnMF;;AAsMA;EACE,iBAAA;AAnMF;;AAsMA;EACE,yCAAA;AAnMF;;AAsMA;EACE,oCAAA;EACA,+CAAA;EACA,sDAAA;EACA,8BAAA;AAnMF;;AAsMA;EACE,gDAAA;EACA,kDAAA;EACA,0DAAA;AAnMF;;AAsMA;EACE,yBAAA;EACA,2FAAA;EAKA,0BAAA;AAvMF;;AA0MA;EACE,YAAA;EACA,aAAA;EACA,0BAAA;AAvMF;;AA0MA;;EAEE,+CAAA;EACA,kDAAA;AAvMF;;AA0MA;EACE,yCAAA;AAvMF;;AA0MA;;EAEE,yBAAA;EACA,2FAAA;AAvMF;;AA8MA;EACE,oCAAA;AA3MF;;AA8MA;EACE,0CAAA;AA3MF;;AA8MA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AA3MF;;AA8MA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA3MF;;AA8MA;EACE,cAAA;AA3MF;;AA8MA,sBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,iCAAA;EACA,0CAAA;EACA,kDAAA;EACA,mDAAA;AA3MF;;AA8MA;EACE,uBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,+CAAA;AA3MF;;AA8MA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sCAAA;EACA,sCAAA;EACA,mBAAA;EACA,oFACE;EAEF,0CAAA;EACA,kDAAA;AA7MF;;AAgNA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,6DAAA;EACA,qBAAA;AA7MF;;AAgNA;EACE,UAAA;AA7MF;;AAgNA;EAGE,qCAAA;EACA,mBAAA;AA/MF;;AAkNA;EAGE,8BAAA;EACA,mBAAA;AAjNF;;AAoNA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,0CAAA;EACA,kGACE;AAlNJ;;AAwNA;EACE,cAAA;EACA,mCAAA;EACA,qCAAA;EACA,wBAAA;AArNF;;AAwNA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,4CAAA;AArNF;;AAwNA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,qDAAA;AArNF;;AAwNA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AArNF;;AAwNA;EACE,mCAAA;AArNF;;AAwNA;EACE,mBAAA;EACA,mBAAA;AArNF;;AAwNA;EACE,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AArNF;;AAwNA;EACE,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;EACA,gBAAA;EACA,iBAAA;AArNF;;AAwNA;EACE,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AArNF;;AAwNA;EACE,gBAAA;AArNF;;AAwNA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AArNF;;AAwNA;EACE,aAAA;AArNF;;AAwNA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,yHACE;AAtNJ;;AA6NA;EACE,kBAAA;EACA,8BAAA;EACA,eAAA;AA1NF;;AA6NA;EACE,cAAA;EACA,gFAAA;EAKA,yBAAA;EACA,2CAAA;EACA,2BAAA;AA9NF;;AAiOA;EACE,cAAA;AA9NF;;AAiOA;EACE;IACE,UAAA;EA9NF;AACF;AAiOA;EACE;IACE,UAAA;IACA,uCAAA;EA/NF;AACF;AAkOA;EACE;IACE,aAAA;EAhOF;EAmOA;IACE,+BAAA;EAjOF;EAoOA;IACE,mBAAA;EAlOF;EAqOA;IACE,aAAA;EAnOF;EAsOA;IACE,SAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EApOF;EAuOA;IACE,kBAAA;IACA,mBAAA;IACA,mBAAA;EArOF;EAwOA;IACE,gBAAA;EAtOF;EAyOA;IACE,mBAAA;IACA,eAAA;IACA,iBAAA;EAvOF;EA0OA;IACE,sBAAA;EAxOF;EA2OA;IACE,WAAA;EAzOF;AACF;AA4OA;EACE,0CAAA;EACA,2CAAA;EACA,kDAAA;AA1OF;;AA6OA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gKACE;EAOF,2CAAA;EACA,kBAAA;EACA,wIACE;EAGF,aAAA;EACA,0BAAA;EACA,kCAAA;AApPF;;AAuPA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AApPF;;AAuPA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AApPF;;AAuPA;EACE,0CAAA;EACA,mBAAA;AApPF;;AAuPA;EACE;IACE,UAAA;IACA,2BAAA;EApPF;EAsPA;IACE,UAAA;IACA,wBAAA;EApPF;AACF;AAuPA;EACE;IACE,iBAAA;EArPF;EAwPA;IACE,0DAAA;IACA,gBAAA;IACA,+BAAA;EAtPF;EAyPA;IACE,kBAAA;EAvPF;EA0PA;IACE,mBAAA;EAxPF;EA2PA;IACE,eAAA;EAzPF;EA4PA;IACE,eAAA;EA1PF;EA6PA;IAGE,iBAAA;EA7PF;EAgQA;IACE,iBAAA;EA9PF;EAiQA;IACE,aAAA;EA/PF;EAkQA;IACE,YAAA;IACA,aAAA;EAhQF;EAmQA;IACE,YAAA;IACA,aAAA;EAjQF;EAoQA;IACE,eAAA;EAlQF;AACF;AAqQA;EACE;IACE,oBAAA;EAnQF;EAsQA;IACE,aAAA;IACA,8BAAA;EApQF;EAuQA;;IAEE,gBAAA;EArQF;EAwQA;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EAtQF;EAyQA;IAGE,gBAAA;IACA,gBAAA;IACA,mBAAA;EAzQF;EA4QA;IACE,kBAAA;EA1QF;EA6QA;IACE,mBAAA;EA3QF;EA8QA;IACE,YAAA;IACA,aAAA;IACA,8BAAA;EA5QF;EA+QA;IACE,aAAA;EA7QF;EAgRA;IACE,YAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;EA9QF;EAiRA;IACE,YAAA;IACA,kBAAA;EA/QF;EAkRA;IACE,YAAA;IACA,mBAAA;EAhRF;EAmRA;IACE,gBAAA;IACA,mBAAA;EAjRF;EAoRA;IACE,WAAA;IACA,YAAA;EAlRF;EAqRA;IACE,YAAA;IACA,kBAAA;EAnRF;EAsRA;IACE,gBAAA;IACA,kBAAA;IACA,iBAAA;EApRF;EAuRA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;EArRF;EAwRA;IACE,kBAAA;IACA,eAAA;EAtRF;EAyRA;IACE,gBAAA;IACA,mBAAA;IACA,iBAAA;EAvRF;EA0RA;IACE,gBAAA;IACA,mBAAA;EAxRF;EA2RA;IACE,WAAA;IACA,YAAA;EAzRF;EA4RA;IACE,kBAAA;IACA,eAAA;EA1RF;EA6RA;IACE,gBAAA;IACA,kBAAA;IACA,iBAAA;EA3RF;EA8RA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EA5RF;EA+RA;IACE,iBAAA;EA7RF;EAgSA;IACE,iBAAA;IACA,iBAAA;IACA,oBAAA;EA9RF;EAiSA;IACE,iBAAA;IACA,oBAAA;EA/RF;EAkSA;IACE,mBAAA;EAhSF;EAmSA;IACE,eAAA;EAjSF;EAoSA;;IAEE,kBAAA;IACA,eAAA;IACA,iBAAA;EAlSF;EAqSA;IACE,eAAA;EAnSF;EAsSA;IACE,iBAAA;EApSF;AACF;AAuSA;EACE;IACE,YAAA;IACA,iBAAA;IACA,oBAAA;IACA,mBAAA;IACA,6BAAA;EArSF;EAwSA;IACE,qCAAA;IACA,6DACE;IAIF,SAAA;IACA,8BAAA;IACA,gBAAA;EA1SF;EA6SA;;;;IAIE,WAAA;EA3SF;EA8SA;IACE,mBAAA;EA5SF;EA+SA;IACE,WAAA;EA7SF;EAgTA;;IAEE,aAAA;EA9SF;EAiTA;IACE,qBAAA;EA/SF;EAkTA;IACE,sBAAA;IACA,oBAAA;EAhTF;EAmTA;IACE,wBAAA;IACA,qCAAA;IACA,WAAA;IACA,UAAA;EAjTF;EAoTA;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;EAlTF;EAqTA;IAGE,mBAAA;IACA,gBAAA;EArTF;EAwTA;IACE,4BAAA;IACA,0BAAA;EAtTF;EAyTA;IACE,0BAAA;IACA,oBAAA;EAvTF;EA0TA;IACE,gBAAA;IACA,cAAA;EAxTF;EA2TA;IACE,aAAA;EAzTF;EA4TA;IACE,YAAA;IACA,aAAA;EA1TF;EA6TA;IACE,UAAA;IACA,WAAA;EA3TF;EA8TA;IACE,YAAA;IACA,aAAA;EA5TF;AACF;AA+TA;EACE;IACE,iBAAA;EA7TF;EAgUA;IACE,SAAA;IACA,8BAAA;EA9TF;EAiUA;;IAEE,WAAA;IACA,YAAA;EA/TF;EAkUA;IACE,gBAAA;IACA,0BAAA;IACA,mBAAA;EAhUF;EAmUA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;EAjUF;EAoUA;IACE,QAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;EAlUF;EAqUA;IACE,YAAA;EAnUF;EAsUA;IACE,iBAAA;IACA,eAAA;EApUF;EAuUA;IACE,eAAA;EArUF;EAwUA;IACE,WAAA;IACA,WAAA;IACA,YAAA;EAtUF;EAyUA;IACE,YAAA;IACA,mBAAA;EAvUF;EA0UA;IAGE,sBAAA;IACA,gBAAA;IACA,gBAAA;EA1UF;EA6UA;IACE,WAAA;IACA,YAAA;IACA,0BAAA;IACA,kBAAA;IACA,0BAAA;EA3UF;EA8UA;IACE,eAAA;IACA,gBAAA;IACA,0BAAA;IACA,uBAAA;EA5UF;EA+UA;IACE,kBAAA;IACA,mBAAA;EA7UF;EAgVA;IACE,uBAAA;IACA,aAAA;IACA,8BAAA;EA9UF;EAiVA;IACE,uBAAA;IACA,aAAA;IACA,mBAAA;EA/UF;EAkVA;IACE,iBAAA;IACA,uBAAA;EAhVF;EAmVA;IACE,YAAA;EAjVF;EAoVA;IACE,eAAA;EAlVF;EAqVA;IACE,uBAAA;EAnVF;EAsVA;IACE,SAAA;EApVF;EAuVA;IACE,eAAA;EArVF;EAwVA;IACE,eAAA;EAtVF;EAyVA;IACE,eAAA;EAvVF;EA0VA;IAGE,8BAAA;IACA,6BAAA;EA1VF;AACF;AA6VA;EACE;;;IAGE,gCAAA;IACA,qCAAA;IACA,uCAAA;IACA,sCAAA;EA3VF;AACF;AA8VA,2BAAA;AACA;EACE,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,6CAAA;EACA,8CAAA;EACA;;;;;GAAA;EAMA,6CAAA;EACA,0CAAA;EACA,+CAAA;EACA,iDAAA;EACA,yBAAA;EACA,4BAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;AA5VF;;AA+VA;EACE,sBAAA;EACA,0CAAA;EACA,0CAAA;EACA;;;;;GAAA;EAMA,8CAAA;EACA,0CAAA;EACA,+CAAA;EACA,kDAAA;AA5VF;;AA+VA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,iNACE;AA7VJ;;AA2WA;EAEE,wNACE;AA1WJ;;AAwXA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AArXF;;AAwXA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AArXF;;AAwXA;EACE,mBAAA;AArXF;;AAwXA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iCAAA;EACA,sCAAA;EACA,qFACE;EAEF,2BAAA;EACA,2BAAA;EACA,mCAAA;AAvXF;;AA0XA;EACE,uCAAA;AAvXF;;AA0XA;EACE,0CAAA;EACA,mBAAA;AAvXF;;AA0XA;EACE,cAAA;EACA,qCAAA;AAvXF;;AA0XA;EACE,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0CAAA;EACA,iDAAA;EACA,mBAAA;EACA,gHACE;EAGF,0CAAA;EACA,kDAAA;EACA,kBAAA;AA1XF;;AA6XA;EAEE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,oFAAA;EAKA,4BAAA;EACA,iBAAA;EACA,aAAA;AA/XF;;AAkYA;EAEE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,+GAAA;EAOA,mBAAA;AAtYF;;AAyYA;EACE,kBAAA;EACA,UAAA;AAtYF;;AAyYA;EACE,6BAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,2BAAA;AAtYF;;AAyYA;EACE,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,6CAAA;EACA,oDAAA;EACA,8BAAA;EACA,qHACE;AAvYJ;;AA4YA;EACE,gBAAA;EACA,8BAAA;EACA,oCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;AAzYF;;AA4YA;EACE,yBAAA;AAzYF;;AA4YA;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,mGAAA;EAKA,0CAAA;EACA,mDAAA;AA7YF;;AAgZA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qFAAA;EAKA,0CAAA;EACA,mBAAA;EACA,uHACE;AAlZJ;;AAuZA;EACE,qCAAA;AApZF;;AAuZA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AApZF;;AAuZA;EACE,sBAAA;EACA,qBAAA;EACA,kCAAA;AApZF;;AAuZA;EAEE,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,gGAAA;EAKA,2CAAA;EACA,mBAAA;EACA,kDAAA;AAzZF;;AA4ZA;EAEE,gBAAA;AA1ZF;;AA6ZA;EAGE,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,oGAAA;EAKA,2CAAA;EACA,mBAAA;EACA,mDAAA;AAhaF;;AAmaA;EAIE,yCAAA;EACA,eAAA;AAnaF;;AAsaA;EAGE,SAAA;EACA,YAAA;EACA,uBAAA;AAraF;;AAwaA;EAIE,eAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;AAxaF;;AA2aA;EAIE,eAAA;EACA,oBAAA;EACA,oCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;EACA,6BAAA;AA3aF;;AA8aA;EAIE,yCAAA;AA9aF;;AAibA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gKAAA;EAOA,2CAAA;EACA,kBAAA;EACA,wIACE;EAGF,aAAA;EACA,0BAAA;EACA,kCAAA;AAvbF;;AA0bA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AAvbF;;AA0bA;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AAvbF;;AA0bA;EACE;IACE,kCAAA;IACA,6BAAA;EAvbF;EA0bA;IACE,uBAAA;EAxbF;EA2bA;IACE,WAAA;IACA,YAAA;EAzbF;EA4bA;IACE,2BAAA;IACA,wBAAA;IACA,mBAAA;EA1bF;EA6bA;IACE,WAAA;EA3bF;EA8bA;IACE,uBAAA;IACA,wBAAA;IACA,8BAAA;EA5bF;EA+bA;IACE,mCAAA;EA7bF;EAgcA;IACE,uBAAA;IACA,aAAA;EA9bF;EAicA;;IAEE,WAAA;IACA,YAAA;EA/bF;EAkcA;IACE,UAAA;IACA,WAAA;EAhcF;EAmcA;IACE,YAAA;IACA,aAAA;EAjcF;AACF;AAocA;EACE;;;IAGE,gCAAA;IACA,qCAAA;IACA,uCAAA;IACA,sCAAA;EAlcF;AACF","sourcesContent":["/* Elegant Maderas Theme Variables */\n\n.maderas-elegant {\n  /* Common Brand Colors */\n  --elegant-gold: #c5a059;\n  --elegant-gold-light: #e2c08d;\n  --elegant-gold-dark: #8e6d31;\n  --elegant-gold-gradient: linear-gradient(\n    135deg,\n    #c5a059 0%,\n    #f1d38e 50%,\n    #8e6d31 100%\n  );\n\n  /* Default Dark Theme Variables */\n  --theme-bg: #0d0d0d;\n  --theme-card-bg: #111111;\n  --theme-card-sub-bg: #1a1a1a;\n  --theme-text-primary: #ffffff;\n  --theme-text-secondary: #999999;\n  --theme-text-muted: #777777;\n  --theme-glass-bg: rgba(26, 26, 26, 0.85);\n  --theme-glass-border: rgba(197, 160, 89, 0.3);\n  --theme-input-bg: rgba(255, 255, 255, 0.05);\n  --theme-nav-inactive-bg: rgba(255, 255, 255, 0.04);\n  --theme-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);\n  --theme-border-subtle: rgba(255, 255, 255, 0.05);\n}\n\n/* Light Theme Overrides */\n.maderas-elegant.light-theme {\n  --theme-bg: #f8f9fa;\n  --theme-card-bg: #ffffff;\n  --theme-card-sub-bg: #f1f3f5;\n  --theme-text-primary: #1a1a1a;\n  --theme-text-secondary: #495057;\n  --theme-text-muted: #868e96;\n  --theme-glass-bg: rgba(255, 255, 255, 0.9);\n  --theme-glass-border: rgba(197, 160, 89, 0.4);\n  --theme-input-bg: rgba(0, 0, 0, 0.03);\n  --theme-nav-inactive-bg: rgba(0, 0, 0, 0.05);\n  --theme-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  --theme-border-subtle: rgba(0, 0, 0, 0.05);\n}\n\n.maderas-elegant {\n  background-color: var(--theme-bg) !important;\n  background-image: var(--maderas-background-image) !important;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: var(--theme-text-primary) !important;\n  font-family: \"Poppins\", sans-serif;\n  min-height: 100vh;\n  transition:\n    background-color 0.4s ease,\n    color 0.4s ease;\n}\n\n/* Header / Logo Area */\n.maderas-elegant .bostami-header-area {\n  padding-top: 40px;\n  margin-bottom: 50px;\n}\n\n.maderas-elegant .bostami-header-wrap {\n  background: transparent !important;\n}\n\n.maderas-header-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n}\n\n.theme-toggle-btn-wrap {\n  position: absolute;\n  top: 0;\n  right: 20px;\n  z-index: 100;\n}\n\n.theme-toggle-btn {\n  background: var(--theme-glass-bg);\n  border: 1px solid var(--theme-glass-border);\n  color: var(--elegant-gold);\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.3s;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.theme-toggle-btn:hover {\n  transform: scale(1.1);\n  background: var(--theme-card-sub-bg);\n  border-color: var(--elegant-gold);\n  color: var(--elegant-gold-light);\n}\n\n.maderas-logo-arc {\n  position: absolute;\n  top: -30px;\n  width: 250px;\n  height: 120px;\n  border-top: 2px solid var(--elegant-gold);\n  border-radius: 125px 125px 0 0;\n  opacity: 0.5;\n  box-shadow: 0 -5px 15px rgba(197, 160, 89, 0.2);\n}\n\n.maderas-elegant .bostami-header-logo {\n  text-align: center;\n  z-index: 10;\n  padding: 10px 0;\n}\n\n.maderas-elegant .bostami-header-logo img {\n  margin-left: 0 !important;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Shiny effect for gold buttons and active items */\n@keyframes shiny {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.maderas-elegant .form-btn,\n.maderas-elegant .bastami-main-menu ul li.active {\n  background-size: 200% 200% !important;\n  animation: shiny 3s ease infinite !important;\n}\n\n/* Personal Info Card */\n.maderas-elegant .bostami-parsonal-info-area {\n  background: var(--theme-card-bg) !important; /* Theme-aware background */\n  border: 1px solid var(--theme-border-subtle) !important;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: var(--theme-shadow);\n  margin-top: 0;\n}\n\n.maderas-elegant .bostami-parsonal-info-wrap {\n  text-align: center;\n}\n\n.maderas-elegant .bostami-parsonal-info-img {\n  position: relative;\n  margin-bottom: 25px;\n  display: flex;\n  justify-content: center;\n}\n\n.maderas-elegant .bostami-parsonal-info-img img {\n  border: 2px solid var(--elegant-gold) !important;\n  padding: 10px;\n  border-radius: 25px !important;\n  background: transparent !important;\n}\n\n.maderas-elegant .bostami-parsonal-info-name {\n  color: var(--theme-text-primary) !important;\n  font-family: \"Roboto Slab\", serif;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  text-align: center;\n}\n\n.maderas-elegant .bostami-parsonal-info-bio {\n  color: var(--theme-text-primary) !important; /* Higher contrast */\n  background: var(--theme-card-sub-bg) !important;\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 2px;\n  text-align: center;\n  display: inline-block;\n  margin: 0 auto 20px;\n  padding: 5px 25px;\n  border-radius: 30px;\n  border: 1px solid var(--theme-border-subtle);\n}\n\n/* Ensure the contact wrap itself is transparent to avoid dark boxes from base theme */\n.maderas-elegant .bostami-parsonal-info-contact {\n  background: transparent !important;\n  padding: 0 !important;\n  border: none !important;\n}\n\n.maderas-elegant .bostami-parsonal-info-contact-item {\n  background: var(--theme-card-sub-bg) !important; /* Theme-aware box */\n  border-radius: 12px;\n  margin-bottom: 15px;\n  padding: 10px 10px;\n  border: 1px solid var(--theme-border-subtle);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.maderas-elegant .bostami-parsonal-info-contact-item .icon {\n  background: rgba(197, 160, 89, 0.2) !important; /* Goldish background box */\n  width: 38px; /* Slightly smaller icon box */\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  min-width: 38px;\n  -webkit-text-fill-color: initial !important;\n  background-clip: initial !important;\n  -webkit-background-clip: initial !important;\n}\n\n.maderas-elegant .bostami-parsonal-info-contact-item .icon i {\n  color: var(--elegant-gold-light) !important;\n  font-size: 16px;\n}\n\n.maderas-elegant .bostami-parsonal-info-contact-item .text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0; /* Important for flex child to allow inner content to shrink */\n}\n\n.maderas-elegant .bostami-parsonal-info-contact-item .text span {\n  color: var(--theme-text-muted) !important;\n  text-transform: uppercase;\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  margin-bottom: 1px;\n}\n\n.maderas-elegant .bostami-parsonal-info-contact-item .text p,\n.maderas-elegant .bostami-parsonal-info-contact-item .text a {\n  color: var(--theme-text-primary) !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  margin: 0 !important;\n  white-space: nowrap;\n}\n\n.maderas-elegant .bostami-parsonal-info-social-link li a {\n  background: var(--theme-border-subtle) !important;\n  color: var(--elegant-gold) !important;\n  transition: 0.3s;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.maderas-elegant .bostami-parsonal-info-social-link {\n  gap: 10px;\n}\n\n/* Navigation / Tabs */\n.maderas-elegant .bostami-main-menu-wrap {\n  background: var(--theme-glass-bg) !important;\n  border: 1px solid var(--theme-glass-border) !important;\n  border-radius: 15px;\n  padding: 10px;\n}\n\n.maderas-elegant .bastami-main-menu ul {\n  background: transparent !important;\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.maderas-elegant .bastami-main-menu ul li {\n  margin: 0 5px;\n  border-radius: 12px;\n  transition: 0.3s;\n  color: var(--theme-text-secondary) !important;\n  cursor: pointer;\n  width: 105px;\n  padding: 12px 0;\n  background: var(--theme-nav-inactive-bg) !important;\n  border: 1px solid var(--theme-border-subtle);\n}\n\n.maderas-elegant .bastami-main-menu ul li:hover {\n  background: var(--theme-border-subtle) !important;\n  color: var(--theme-text-primary) !important;\n}\n\n.maderas-elegant .menu-item-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.maderas-elegant .menu-item-content .icon {\n  font-size: 24px;\n  margin-bottom: 8px;\n}\n\n.maderas-elegant .bastami-main-menu ul li.active {\n  background: var(--elegant-gold-gradient) !important;\n  color: #fff !important;\n  box-shadow: 0 5px 15px rgba(197, 160, 89, 0.3);\n}\n\n.maderas-elegant .bastami-main-menu ul li.active i {\n  color: #fff !important;\n}\n\n/* Content Area */\n.maderas-elegant .bostami-page-content-wrap {\n  background: var(--theme-glass-bg) !important;\n  border: 1px solid var(--theme-glass-border) !important;\n  border-radius: 20px;\n  color: var(--theme-text-primary);\n  overflow: hidden;\n  position: relative;\n}\n\n.maderas-elegant .section-wrapper {\n  background: transparent !important;\n}\n\n.maderas-elegant .bg-light-white-2 {\n  background: var(--theme-input-bg) !important;\n  border-top: 1px solid var(--theme-glass-border);\n}\n\n.maderas-elegant .page-title,\n.maderas-elegant .section-title {\n  font-family: \"Roboto Slab\", serif;\n  color: var(--elegant-gold-light) !important;\n  font-weight: 700;\n}\n\n.maderas-elegant .bostami-page-title-wrap p,\n.maderas-elegant .section-wrapper p {\n  color: var(--theme-text-primary) !important;\n  opacity: 0.9;\n}\n\n.maderas-elegant .bostami-page-title-wrap::after {\n  content: \"\";\n  display: block;\n  width: 60px;\n  height: 3px;\n  background: var(--elegant-gold-gradient);\n  margin-top: 10px;\n}\n\n/* Sparkle effect like in the image */\n.maderas-elegant .bostami-page-content-wrap::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100px;\n  background-image:\n    radial-gradient(\n      circle at 10% 20%,\n      rgba(197, 160, 89, 0.1) 1px,\n      transparent 1px\n    ),\n    radial-gradient(\n      circle at 30% 50%,\n      rgba(197, 160, 89, 0.1) 1px,\n      transparent 1px\n    ),\n    radial-gradient(\n      circle at 70% 30%,\n      rgba(197, 160, 89, 0.1) 1px,\n      transparent 1px\n    ),\n    radial-gradient(\n      circle at 90% 70%,\n      rgba(197, 160, 89, 0.1) 1px,\n      transparent 1px\n    );\n  background-size: 50px 50px;\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.maderas-elegant .bostami-client-slider-logo {\n  filter: none !important;\n  opacity: 1 !important;\n}\n\n.maderas-elegant .contact-area {\n  background: transparent !important;\n  padding: 20px 0;\n}\n\n.maderas-elegant .form-input-item label {\n  color: var(--elegant-gold-light) !important;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.maderas-elegant .form-input-item .input-box {\n  background: var(--theme-input-bg) !important;\n  border: 1px solid var(--theme-glass-border) !important;\n  border-radius: 10px !important;\n  color: var(--theme-text-primary) !important;\n  padding: 12px 15px !important;\n  transition: 0.3s;\n}\n\n.maderas-elegant .form-input-item .input-box:focus {\n  border-color: var(--elegant-gold) !important;\n  box-shadow: 0 0 10px rgba(197, 160, 89, 0.2) !important;\n  background: rgba(255, 255, 255, 0.08) !important;\n}\n\n.maderas-elegant .form-btn {\n  background: var(--elegant-gold-gradient) !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 30px !important;\n  padding: 12px 35px !important;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 5px 15px rgba(197, 160, 89, 0.3) !important;\n  transition: 0.3s;\n}\n\n.maderas-elegant .form-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(197, 160, 89, 0.4) !important;\n}\n\n.maderas-elegant .footer-copyright {\n  background: rgba(0, 0, 0, 0.05) !important;\n  border-top: 1px solid var(--theme-glass-border) !important;\n  color: var(--theme-text-muted) !important;\n}\n\n/* Portfolio grid elegance */\n.maderas-elegant .portfolio-item-wrap {\n  background: var(--theme-input-bg) !important;\n  border: 1px solid var(--theme-glass-border) !important;\n  border-radius: 15px !important;\n  padding: 15px;\n  transition: 0.3s;\n}\n\n.maderas-elegant .portfolio-item-wrap:hover {\n  border-color: var(--elegant-gold) !important;\n  transform: translateY(-5px);\n}\n\n/* Portfolio filters */\n.maderas-elegant .fillter-btn-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  row-gap: 15px; /* Spacing between rows when buttons wrap */\n  justify-content: center;\n  padding: 0 10px;\n}\n\n.maderas-elegant .fillter-btn {\n  background: var(--theme-input-bg) !important;\n  border: 1px solid var(--theme-glass-border) !important;\n  color: var(--theme-text-secondary) !important;\n  padding: 8px 20px !important;\n  border-radius: 20px !important;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.maderas-elegant .fillter-btn:hover,\n.maderas-elegant .fillter-btn.is-checked {\n  background: var(--elegant-gold-gradient) !important;\n  color: #fff !important;\n  border-color: transparent !important;\n}\n\n.maderas-elegant .fillter-item {\n  background: var(--theme-input-bg) !important;\n  border: 1px solid var(--theme-glass-border) !important;\n  border-radius: 15px !important;\n  padding: 15px !important;\n  margin-bottom: 20px;\n  transition: 0.3s;\n}\n\n.maderas-elegant .fillter-item .item-title {\n  color: var(--elegant-gold-light) !important;\n  font-weight: 600;\n  margin-top: 15px;\n}\n\n.maderas-elegant .fillter-item .item-subtitle {\n  color: var(--theme-text-muted) !important;\n  font-size: 13px;\n}\n\n.maderas-elegant .fillter-item .img {\n  border-radius: 10px;\n  overflow: hidden;\n  display: block;\n}\n\n/* Elegant curve background element (Top Right) */\n.elegant-curve-bg {\n  position: fixed;\n  top: -200px;\n  right: -300px;\n  width: 800px;\n  height: 1200px;\n  border-left: 1.5px solid rgba(197, 160, 89, 0.25);\n  border-radius: 50%;\n  transform: rotate(-15deg);\n  pointer-events: none;\n  z-index: 0; /* Ensure it stays behind content but visible on background */\n}\n\n/* Elegant curve background element (Bottom Left) */\n.elegant-curve-bg-2 {\n  position: fixed;\n  bottom: -300px;\n  left: -400px;\n  width: 1000px;\n  height: 1000px;\n  border-right: 1.5px solid rgba(197, 160, 89, 0.2);\n  border-radius: 50%;\n  transform: rotate(-10deg);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Extra decorative lines like in the image */\n.maderas-elegant .bostami-parsonal-info-wrap::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 40px;\n  height: 40px;\n  background-image: radial-gradient(var(--elegant-gold) 1px, transparent 1px);\n  background-size: 8px 8px;\n  opacity: 0.3;\n}\n\n/* Responsive Navigation for Mobile */\n@media (max-width: 991px) {\n  .maderas-elegant.home-3 .bostami-main-menu-wrap,\n  .maderas-elegant .home-3 .bostami-main-menu-wrap {\n    display: block !important;\n    margin: 0 auto 30px !important;\n    width: 100% !important;\n    float: none !important;\n  }\n\n  .maderas-elegant .bastami-main-menu ul {\n    display: flex !important;\n    justify-content: space-between !important;\n    width: 100%;\n    padding: 0 5px;\n  }\n\n  .maderas-elegant .bastami-main-menu ul li {\n    width: calc(33.33% - 8px) !important;\n    margin: 0 4px !important;\n    padding: 12px 0 !important;\n    height: auto !important;\n    min-width: unset !important;\n  }\n\n  .maderas-elegant .menu-item-content .icon {\n    font-size: 22px !important;\n    margin-bottom: 6px !important;\n  }\n\n  .maderas-elegant .menu-item-content .text {\n    font-size: 10px !important;\n    font-weight: 500;\n    text-transform: capitalize;\n    white-space: nowrap;\n  }\n\n  /* Hide the default mobile hamburger menu if it exists, as we are using the tabs */\n  .maderas-elegant .mobile-menu-btn,\n  .maderas-elegant .mobile-menu-wrap {\n    display: none !important;\n  }\n}\n\n/* QR View Specific Styles */\n.qr-view-container {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  min-height: 100vh !important;\n  padding: 40px 20px !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.qr-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 10;\n  width: 100%;\n  max-width: 400px;\n  position: relative;\n}\n\n.qr-theme-toggle {\n  top: -50px;\n  right: 0;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-area {\n  margin-top: 100px !important;\n  width: 100% !important;\n  max-width: 380px !important;\n  position: relative;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-img {\n  position: absolute !important;\n  top: -110px;\n  left: 50%;\n  transform: translateX(-50%);\n  margin-bottom: 0 !important;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-img img {\n  width: 200px !important;\n  height: 200px !important;\n  object-fit: cover;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-name {\n  margin-top: 100px !important; /* Push down after absolutely positioned image */\n  margin-bottom: 25px !important;\n}\n\n.qr-code-container {\n  background: var(--theme-input-bg);\n  padding: 20px;\n  border-radius: 20px;\n  border: 1px solid var(--theme-glass-border);\n  margin-bottom: 30px;\n  box-shadow: 0 0 20px rgba(197, 160, 89, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.qr-code-canvas {\n  filter: drop-shadow(0 0 5px rgba(197, 160, 89, 0.3));\n}\n\n.qr-footer-logo {\n  margin-top: 40px;\n  opacity: 0.8;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-contact {\n  width: 100% !important;\n  padding: 0 5px !important; /* Reduced side padding to gain space */\n  background-color: transparent !important; /* Fix the white box */\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item {\n  padding: 12px 15px !important;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-contact-item .text a {\n  white-space: normal !important; /* Allow wrapping */\n  word-break: break-all !important;\n  line-height: 1.2;\n}\n\n/* Ensure curve animations are subtle in QR view too */\n.maderas-elegant.qr-view-container .elegant-curve-bg,\n.maderas-elegant.qr-view-container .elegant-curve-bg-2 {\n  opacity: 0.6;\n}\n\n/* Living Maderas premium card redesign */\n.maderas-elegant.home-3 {\n  --living-navy: #071526;\n  --living-slate: #142b43;\n  --living-gold: #d8b978;\n  --living-gold-soft: #f0d99d;\n  --living-text: #f8fbff;\n  --living-text-soft: rgba(234, 242, 250, 0.78);\n  --living-text-muted: rgba(224, 234, 244, 0.58);\n  --living-skeleton-base: rgba(204, 225, 242, 0.1);\n  --living-skeleton-highlight: rgba(241, 248, 255, 0.26);\n  --living-glass: linear-gradient(\n    145deg,\n    rgba(39, 62, 87, 0.58) 0%,\n    rgba(8, 25, 43, 0.46) 55%,\n    rgba(5, 18, 33, 0.58) 100%\n  );\n  --living-glass-strong: linear-gradient(\n    150deg,\n    rgba(44, 67, 91, 0.72) 0%,\n    rgba(8, 26, 45, 0.66) 62%,\n    rgba(5, 18, 33, 0.74) 100%\n  );\n  --living-glass-soft: rgba(164, 191, 216, 0.1);\n  --living-border: rgba(227, 239, 250, 0.34);\n  --living-border-soft: rgba(227, 239, 250, 0.16);\n  --living-shadow: 0 28px 70px rgba(0, 8, 20, 0.36);\n  --theme-card-bg: rgba(9, 27, 46, 0.62);\n  --theme-card-sub-bg: rgba(174, 199, 221, 0.1);\n  --theme-text-primary: var(--living-text);\n  --theme-text-secondary: var(--living-text-soft);\n  --theme-text-muted: var(--living-text-muted);\n  --theme-glass-bg: rgba(10, 29, 49, 0.58);\n  --theme-glass-border: var(--living-border);\n  --theme-input-bg: rgba(193, 214, 232, 0.09);\n  --theme-nav-inactive-bg: rgba(175, 202, 224, 0.08);\n  --theme-shadow: var(--living-shadow);\n  --theme-border-subtle: var(--living-border-soft);\n  position: relative;\n  height: 100vh;\n  min-height: 100vh;\n  padding: 24px 0 34px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-attachment: fixed;\n  isolation: isolate;\n}\n\n.maderas-elegant.home-3.light-theme {\n  --living-text: #11263b;\n  --living-text-soft: rgba(17, 38, 59, 0.78);\n  --living-text-muted: rgba(17, 38, 59, 0.6);\n  --living-skeleton-base: rgba(40, 78, 110, 0.1);\n  --living-skeleton-highlight: rgba(255, 255, 255, 0.7);\n  --living-glass: linear-gradient(\n    145deg,\n    rgba(247, 251, 255, 0.76) 0%,\n    rgba(226, 238, 248, 0.62) 58%,\n    rgba(213, 229, 241, 0.7) 100%\n  );\n  --living-glass-strong: linear-gradient(\n    150deg,\n    rgba(255, 255, 255, 0.86) 0%,\n    rgba(229, 240, 249, 0.76) 100%\n  );\n  --living-glass-soft: rgba(255, 255, 255, 0.42);\n  --living-border: rgba(255, 255, 255, 0.7);\n  --living-border-soft: rgba(255, 255, 255, 0.46);\n  --living-shadow: 0 26px 66px rgba(6, 27, 47, 0.22);\n  --theme-card-bg: rgba(241, 248, 253, 0.74);\n  --theme-card-sub-bg: rgba(255, 255, 255, 0.44);\n  --theme-text-primary: var(--living-text);\n  --theme-text-secondary: var(--living-text-soft);\n  --theme-text-muted: var(--living-text-muted);\n  --theme-glass-bg: rgba(236, 246, 253, 0.7);\n  --theme-glass-border: var(--living-border);\n  --theme-input-bg: rgba(255, 255, 255, 0.42);\n  --theme-nav-inactive-bg: rgba(255, 255, 255, 0.38);\n  --theme-shadow: var(--living-shadow);\n  --theme-border-subtle: var(--living-border-soft);\n}\n\n.maderas-elegant.home-3 .living-background-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n  background:\n    linear-gradient(\n      90deg,\n      rgba(1, 12, 27, 0.58) 0%,\n      rgba(4, 18, 34, 0.34) 31%,\n      rgba(7, 22, 38, 0.08) 57%,\n      rgba(2, 14, 29, 0.26) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(2, 13, 27, 0.22) 0%,\n      transparent 42%,\n      rgba(1, 10, 22, 0.44) 100%\n    );\n}\n\n.maderas-elegant.home-3.light-theme .living-background-overlay {\n  background:\n    linear-gradient(\n      90deg,\n      rgba(9, 27, 47, 0.34) 0%,\n      rgba(16, 37, 57, 0.12) 45%,\n      rgba(7, 23, 40, 0.18) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(209, 228, 242, 0.08) 0%,\n      transparent 50%,\n      rgba(3, 17, 32, 0.24) 100%\n    );\n}\n\n.maderas-elegant.home-3 .living-dashboard {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: minmax(330px, 366px) minmax(0, 1fr);\n  grid-template-areas:\n    \"brand navigation\"\n    \"profile content\";\n  column-gap: clamp(30px, 4.2vw, 68px);\n  row-gap: 20px;\n  width: min(100% - 40px, 1280px);\n  max-width: 1280px;\n  min-height: calc(100vh - 58px);\n  margin: 0 auto;\n  padding: 0;\n  align-content: start;\n}\n\n.maderas-elegant.home-3 .living-skeleton {\n  display: block;\n  overflow: hidden;\n  background:\n    linear-gradient(\n      100deg,\n      transparent 20%,\n      var(--living-skeleton-highlight) 42%,\n      transparent 64%\n    )\n    100% 0 / 220% 100%,\n    var(--living-skeleton-base);\n  border: 1px solid var(--living-border-soft);\n  animation: living-skeleton-shimmer 1.5s ease-in-out infinite;\n}\n\n.maderas-elegant.home-3 .living-loading-navigation__inner {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 7px;\n  width: 100%;\n  padding: 7px;\n  background: var(--living-glass);\n  border: 1px solid var(--living-border);\n  border-radius: 23px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.22),\n    0 20px 48px rgba(0, 8, 20, 0.24);\n  backdrop-filter: blur(22px) saturate(125%);\n  -webkit-backdrop-filter: blur(22px) saturate(125%);\n}\n\n.maderas-elegant.home-3 .living-loading-navigation__inner > span {\n  min-height: 56px;\n  border-radius: 16px;\n}\n\n.maderas-elegant.home-3 .living-loading-profile {\n  display: flex;\n  min-height: 560px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.maderas-elegant.home-3 .living-loading-photo {\n  width: min(100%, 258px);\n  height: clamp(220px, 20vw, 258px);\n  margin-bottom: 18px;\n  border-color: rgba(241, 215, 154, 0.42);\n  border-radius: 30px;\n}\n\n.maderas-elegant.home-3 .living-loading-name {\n  width: min(78%, 230px);\n  height: 30px;\n  margin-bottom: 10px;\n  border-radius: 9px;\n}\n\n.maderas-elegant.home-3 .living-loading-badge {\n  width: 88px;\n  height: 30px;\n  margin-bottom: 14px;\n  border-radius: 999px;\n}\n\n.maderas-elegant.home-3 .living-loading-socials {\n  display: flex;\n  min-height: 44px;\n  margin-bottom: 18px;\n  gap: 9px;\n}\n\n.maderas-elegant.home-3 .living-loading-socials > span {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n}\n\n.maderas-elegant.home-3 .living-loading-heading {\n  align-self: flex-start;\n  width: 104px;\n  height: 20px;\n  margin-bottom: 10px;\n  border-radius: 7px;\n}\n\n.maderas-elegant.home-3 .living-loading-contacts {\n  width: 100%;\n}\n\n.maderas-elegant.home-3 .living-loading-contact {\n  display: flex;\n  min-height: 64px;\n  margin-bottom: 10px;\n  padding: 10px 12px;\n  align-items: center;\n  gap: 12px;\n  background: rgba(196, 217, 234, 0.07);\n  border: 1px solid var(--living-border-soft);\n  border-radius: 16px;\n}\n\n.maderas-elegant.home-3 .living-loading-contact:last-child {\n  margin-bottom: 0;\n}\n\n.maderas-elegant.home-3 .living-loading-contact__icon {\n  flex: 0 0 42px;\n  width: 42px;\n  height: 42px;\n  border-radius: 13px;\n}\n\n.maderas-elegant.home-3 .living-loading-contact__text {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.maderas-elegant.home-3 .living-loading-contact__text > span:first-child {\n  width: 38%;\n  height: 8px;\n  border-radius: 4px;\n}\n\n.maderas-elegant.home-3 .living-loading-contact__text > span:last-child {\n  width: 78%;\n  height: 12px;\n  border-radius: 5px;\n}\n\n.maderas-elegant.home-3 .living-loading-content__card {\n  display: flex;\n  min-height: 485px;\n  padding: clamp(34px, 4vw, 52px) clamp(30px, 4.4vw, 58px);\n  flex-direction: column;\n  color: var(--living-text);\n  background: var(--living-glass);\n  border: 1px solid var(--living-border);\n  border-radius: 30px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.28),\n    var(--living-shadow);\n  backdrop-filter: blur(25px) saturate(120%);\n  -webkit-backdrop-filter: blur(25px) saturate(120%);\n}\n\n.maderas-elegant.home-3 .living-loading-copy {\n  width: 100%;\n}\n\n.maderas-elegant.home-3 .living-loading-title {\n  width: min(44%, 250px);\n  height: 44px;\n  margin-bottom: 16px;\n  border-radius: 11px;\n}\n\n.maderas-elegant.home-3 .living-loading-rule {\n  width: min(28%, 150px);\n  height: 3px;\n  margin-bottom: 26px;\n  border: 0;\n  border-radius: 999px;\n}\n\n.maderas-elegant.home-3 .living-loading-line {\n  width: 100%;\n  height: 13px;\n  margin-bottom: 13px;\n  border: 0;\n  border-radius: 6px;\n}\n\n.maderas-elegant.home-3 .living-loading-line--short-1 {\n  width: 64%;\n  margin-bottom: 28px;\n}\n\n.maderas-elegant.home-3 .living-loading-line--medium {\n  width: 76%;\n}\n\n.maderas-elegant.home-3 .living-loading-message {\n  display: flex;\n  width: fit-content;\n  max-width: 100%;\n  margin-top: auto;\n  padding: 13px 16px;\n  align-items: center;\n  gap: 12px;\n  color: var(--living-text);\n  background: var(--living-glass-soft);\n  border: 1px solid var(--living-border-soft);\n  border-radius: 16px;\n}\n\n.maderas-elegant.home-3 .living-loading-message > span:last-child {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n\n.maderas-elegant.home-3 .living-loading-message strong {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.maderas-elegant.home-3 .living-loading-message small {\n  color: var(--living-text-soft);\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n.maderas-elegant.home-3 .living-loading-spinner {\n  flex: 0 0 30px;\n  width: 30px;\n  height: 30px;\n  border: 2px solid var(--living-border);\n  border-top-color: var(--living-gold);\n  border-radius: 50%;\n  animation: living-loading-spin 800ms linear infinite;\n}\n\n.maderas-elegant.home-3 .living-request-error {\n  grid-column: 1 / -1;\n  width: min(100%, 620px);\n  margin: clamp(54px, 10vh, 100px) auto 0;\n  padding: clamp(30px, 5vw, 48px);\n  color: var(--living-text);\n  text-align: center;\n  background: var(--living-glass-strong);\n  border: 1px solid var(--living-border);\n  border-radius: 30px;\n  box-shadow: var(--living-shadow);\n  backdrop-filter: blur(24px) saturate(125%);\n  -webkit-backdrop-filter: blur(24px) saturate(125%);\n}\n\n.maderas-elegant.home-3 .living-request-error__icon {\n  display: grid;\n  width: 58px;\n  height: 58px;\n  margin: 0 auto 20px;\n  place-items: center;\n  color: var(--living-gold-soft);\n  font-size: 25px;\n  background: var(--living-glass-soft);\n  border: 1px solid var(--living-border);\n  border-radius: 18px;\n}\n\n.maderas-elegant.home-3 .living-request-error h1 {\n  margin: 0 0 10px;\n  color: var(--living-text);\n  font-family: \"Roboto Slab\", serif;\n  font-size: clamp(25px, 4vw, 34px);\n  font-weight: 500;\n}\n\n.maderas-elegant.home-3 .living-request-error p {\n  margin: 0 auto 24px;\n  color: var(--living-text-soft);\n  font-size: 14px;\n}\n\n.maderas-elegant.home-3 .living-retry-button {\n  display: inline-flex;\n  min-height: 46px;\n  padding: 11px 20px;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  color: #ffffff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  background: linear-gradient(\n    145deg,\n    rgba(63, 132, 181, 0.94),\n    rgba(16, 72, 119, 0.92)\n  );\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 14px;\n  box-shadow: 0 10px 22px rgba(10, 67, 111, 0.28);\n  cursor: pointer;\n  transition:\n    transform 200ms ease,\n    box-shadow 200ms ease;\n}\n\n.maderas-elegant.home-3 .living-retry-button:hover {\n  color: #ffffff;\n  box-shadow: 0 13px 26px rgba(10, 67, 111, 0.36);\n  transform: translateY(-2px);\n}\n\n@keyframes living-skeleton-shimmer {\n  to {\n    background-position: -120% 0;\n  }\n}\n\n@keyframes living-loading-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.maderas-elegant.home-3 .living-brand-bar {\n  position: relative;\n  grid-area: brand;\n  display: block;\n  min-width: 0;\n}\n\n.maderas-elegant.home-3 .living-brand-lockup,\n.maderas-elegant.qr-view-container .living-brand-lockup {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 86px;\n  padding: 12px 24px;\n  overflow: hidden;\n  color: var(--living-text);\n  background: var(--living-glass);\n  border: 1px solid var(--living-border);\n  border-radius: 24px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.3),\n    0 0 0 1px rgba(180, 216, 244, 0.08),\n    0 0 24px rgba(136, 190, 229, 0.12),\n    var(--living-shadow);\n  backdrop-filter: blur(18px) saturate(125%);\n  -webkit-backdrop-filter: blur(18px) saturate(125%);\n  transition:\n    transform 220ms ease,\n    border-color 220ms ease,\n    background-color 220ms ease;\n}\n\n.maderas-elegant.home-3 .living-brand-lockup::before,\n.maderas-elegant.qr-view-container .living-brand-lockup::before {\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  z-index: 3;\n  pointer-events: none;\n  border-radius: inherit;\n  background:\n    linear-gradient(\n        90deg,\n        transparent 4%,\n        rgba(235, 248, 255, 0.9) 15%,\n        transparent 31%\n      )\n      top left / 100% 1.5px no-repeat,\n    linear-gradient(\n        90deg,\n        transparent 52%,\n        rgba(238, 205, 137, 0.72) 72%,\n        transparent 94%\n      )\n      bottom left / 100% 1.5px no-repeat,\n    linear-gradient(\n        180deg,\n        transparent 7%,\n        rgba(226, 244, 255, 0.7) 24%,\n        transparent 43%\n      )\n      top left / 1.5px 100% no-repeat,\n    linear-gradient(\n        180deg,\n        transparent 48%,\n        rgba(238, 205, 137, 0.58) 76%,\n        transparent 94%\n      )\n      top right / 1.5px 100% no-repeat;\n  filter: drop-shadow(0 0 5px rgba(203, 231, 250, 0.34));\n}\n\n.maderas-elegant.home-3 .living-brand-lockup::after,\n.maderas-elegant.qr-view-container .living-brand-lockup::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: linear-gradient(\n    115deg,\n    rgba(255, 255, 255, 0.14),\n    transparent 32%\n  );\n}\n\n.maderas-elegant.home-3 .living-brand-lockup:hover,\n.maderas-elegant.qr-view-container .living-brand-lockup:hover {\n  color: var(--living-text);\n  border-color: rgba(240, 217, 157, 0.52);\n  transform: translateY(-2px);\n}\n\n.maderas-elegant.home-3 .living-brand-mark,\n.maderas-elegant.qr-view-container .living-brand-mark {\n  position: relative;\n  display: grid;\n  z-index: 1;\n  flex: 0 0 60px;\n  width: 60px;\n  height: 52px;\n  place-items: end center;\n  margin-right: -36px;\n  color: var(--living-gold-soft);\n}\n\n.maderas-elegant.home-3 .living-brand-mark::before,\n.maderas-elegant.qr-view-container .living-brand-mark::before {\n  content: \"\";\n  position: absolute;\n  top: 7px;\n  left: 11px;\n  width: 37px;\n  height: 37px;\n  border-top: 2px solid var(--living-gold);\n  border-left: 2px solid var(--living-gold);\n  transform: rotate(45deg);\n}\n\n.maderas-elegant.home-3 .living-brand-mark::after,\n.maderas-elegant.qr-view-container .living-brand-mark::after {\n  content: \"\";\n  position: absolute;\n  right: 6px;\n  bottom: 0;\n  left: 6px;\n  height: 28px;\n  border-right: 2px solid var(--living-gold);\n  border-bottom: 2px solid var(--living-gold);\n  border-left: 2px solid var(--living-gold);\n}\n\n.maderas-elegant.home-3 .living-brand-copy,\n.maderas-elegant.qr-view-container .living-brand-copy {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: baseline;\n  min-width: 0;\n  line-height: 1;\n}\n\n.maderas-elegant.home-3 .living-brand-script,\n.maderas-elegant.qr-view-container .living-brand-script {\n  margin-right: 8px;\n  color: var(--living-text);\n  font-family: Georgia, \"Times New Roman\", serif;\n  font-size: clamp(30px, 2.5vw, 37px);\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: -0.04em;\n}\n\n.maderas-elegant.home-3 .living-brand-copy strong,\n.maderas-elegant.qr-view-container .living-brand-copy strong {\n  color: var(--living-gold);\n  font-family: \"Roboto Slab\", serif;\n  font-size: clamp(18px, 1.5vw, 23px);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n}\n\n.maderas-elegant.home-3 .living-dynamic-brand-logo,\n.maderas-elegant.qr-view-container .living-dynamic-brand-logo {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: auto;\n  max-width: 230px;\n  height: auto;\n  max-height: 58px;\n  margin: 0 auto;\n  object-fit: contain;\n}\n\n.maderas-elegant.home-3 .theme-toggle-btn {\n  position: absolute;\n  top: 50%;\n  right: -62px;\n  z-index: 3;\n  width: 48px;\n  height: 48px;\n  color: var(--living-gold-soft);\n  background: var(--living-glass-strong);\n  border: 1px solid var(--living-border);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.24),\n    0 14px 30px rgba(0, 8, 20, 0.28);\n  transform: translateY(-50%);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.maderas-elegant.home-3 .theme-toggle-btn:hover {\n  color: var(--living-gold-soft);\n  background: var(--living-glass-strong);\n  border-color: rgba(240, 217, 157, 0.58);\n  transform: translateY(-50%) scale(1.06);\n}\n\n.maderas-elegant.home-3 .living-navigation {\n  grid-area: navigation;\n  align-self: center;\n  justify-self: end;\n  width: min(100%, 530px);\n}\n\n.maderas-elegant.home-3 .bostami-main-menu-wrap {\n  width: 100%;\n  padding: 7px;\n  background: var(--living-glass) !important;\n  border: 1px solid var(--living-border) !important;\n  border-radius: 23px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.28),\n    0 20px 48px rgba(0, 8, 20, 0.3);\n  backdrop-filter: blur(22px) saturate(125%);\n  -webkit-backdrop-filter: blur(22px) saturate(125%);\n}\n\n.maderas-elegant.home-3 .bastami-main-menu ul {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 3px;\n}\n\n.maderas-elegant.home-3 .bastami-main-menu ul li {\n  width: auto;\n  min-width: 0;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background: transparent !important;\n  border: 0;\n  border-radius: 17px;\n}\n\n.maderas-elegant.home-3 .bastami-main-menu ul li + li {\n  border-left: 1px solid var(--living-border-soft);\n  border-radius: 0 17px 17px 0;\n}\n\n.maderas-elegant.home-3 .bastami-main-menu .menu-item-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 56px;\n  padding: 10px 14px;\n  color: var(--living-text-soft);\n  font: inherit;\n  white-space: nowrap;\n  background: transparent;\n  border: 0;\n  border-radius: 16px;\n  cursor: pointer;\n  transition:\n    color 200ms ease,\n    background-color 200ms ease,\n    box-shadow 200ms ease,\n    transform 200ms ease;\n}\n\n.maderas-elegant.home-3 .menu-item-content .icon {\n  display: grid;\n  width: 34px;\n  height: 34px;\n  margin: 0 8px 0 0;\n  place-items: center;\n  color: var(--living-text-soft);\n  font-size: 18px;\n  background: rgba(198, 220, 239, 0.08);\n  border: 1px solid var(--living-border-soft);\n  border-radius: 11px;\n  transition: inherit;\n}\n\n.maderas-elegant.home-3 .menu-item-content .text {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.maderas-elegant.home-3 .bastami-main-menu ul li:hover {\n  background: transparent !important;\n}\n\n.maderas-elegant.home-3\n  .bastami-main-menu\n  ul\n  li:hover\n  .menu-item-content {\n  color: var(--living-text);\n  background: rgba(206, 225, 241, 0.09);\n}\n\n.maderas-elegant.home-3 .bastami-main-menu ul li.active {\n  background: transparent !important;\n  box-shadow: none;\n  animation: none !important;\n}\n\n.maderas-elegant.home-3\n  .bastami-main-menu\n  ul\n  li.active\n  .menu-item-content {\n  color: #ffffff;\n  background: linear-gradient(\n    145deg,\n    rgba(63, 132, 181, 0.78),\n    rgba(16, 72, 119, 0.72)\n  );\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.35),\n    0 8px 18px rgba(10, 67, 111, 0.32);\n}\n\n.maderas-elegant.home-3\n  .bastami-main-menu\n  ul\n  li.active\n  .menu-item-content\n  .icon {\n  color: var(--living-gold-soft);\n  background: rgba(221, 238, 251, 0.12);\n  border-color: rgba(255, 255, 255, 0.22);\n}\n\n.maderas-elegant.home-3 .living-profile-column {\n  grid-area: profile;\n  align-self: start;\n  min-width: 0;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-area {\n  position: relative;\n  top: auto;\n  width: 100%;\n  margin: 0;\n  padding: clamp(24px, 2.4vw, 32px);\n  overflow: hidden;\n  background: var(--living-glass-strong) !important;\n  border: 1px solid var(--living-border) !important;\n  border-radius: 29px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.34),\n    inset 0 -1px 0 rgba(216, 185, 120, 0.12),\n    -9px 7px 0 -3px rgba(214, 233, 247, 0.14),\n    -24px 16px 44px rgba(1, 12, 28, 0.34),\n    var(--living-shadow);\n  backdrop-filter: blur(24px) saturate(125%);\n  -webkit-backdrop-filter: blur(24px) saturate(125%);\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-area::after {\n  content: \"\";\n  position: absolute;\n  top: -35%;\n  left: -20%;\n  width: 120%;\n  height: 56%;\n  pointer-events: none;\n  background: radial-gradient(\n    ellipse,\n    rgba(255, 255, 255, 0.2),\n    transparent 65%\n  );\n  transform: rotate(-12deg);\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-wrap {\n  position: relative;\n  z-index: 1;\n  text-align: center;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-wrap::before {\n  display: none;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-img {\n  margin: 0 auto 18px;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-img img {\n  width: min(100%, 258px);\n  height: clamp(220px, 20vw, 258px);\n  padding: 4px;\n  object-fit: cover;\n  object-position: center;\n  background: rgba(231, 241, 249, 0.12) !important;\n  border: 1px solid rgba(241, 215, 154, 0.8) !important;\n  border-radius: 30px !important;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.4),\n    0 16px 32px rgba(0, 8, 20, 0.28),\n    0 0 24px rgba(216, 185, 120, 0.12);\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-name {\n  max-width: 300px;\n  margin: 0 auto 10px;\n  color: var(--living-text) !important;\n  font-family: \"Roboto Slab\", serif;\n  font-size: clamp(25px, 2.1vw, 31px);\n  font-weight: 500;\n  line-height: 1.13;\n  text-align: center;\n  text-transform: none;\n  letter-spacing: -0.025em;\n  overflow-wrap: anywhere;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-bio {\n  display: inline-flex;\n  align-items: center;\n  min-height: 30px;\n  margin: 0 auto 14px;\n  padding: 5px 18px;\n  color: var(--living-text) !important;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: 0.015em;\n  background: linear-gradient(\n    135deg,\n    rgba(245, 226, 184, 0.76),\n    rgba(176, 132, 66, 0.7)\n  ) !important;\n  border: 1px solid rgba(255, 241, 204, 0.38);\n  border-radius: 999px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.36);\n}\n\n.maderas-elegant.home-3.light-theme .bostami-parsonal-info-bio {\n  color: #ffffff !important;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-social-link {\n  display: flex;\n  width: auto;\n  min-height: 44px;\n  margin: 0 auto 18px;\n  padding: 0;\n  gap: 9px;\n  justify-content: center;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-social-link li a {\n  display: grid;\n  width: 44px;\n  height: 44px;\n  place-items: center;\n  color: var(--living-text) !important;\n  line-height: 1;\n  background: rgba(190, 213, 232, 0.12) !important;\n  border: 1px solid var(--living-border-soft);\n  border-radius: 50%;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  transition:\n    transform 200ms ease,\n    color 200ms ease,\n    background-color 200ms ease,\n    border-color 200ms ease;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-social-link li a:hover {\n  color: var(--living-gold-soft) !important;\n  background: rgba(204, 224, 240, 0.2) !important;\n  border-color: rgba(240, 217, 157, 0.44);\n  transform: translateY(-3px);\n}\n\n.maderas-elegant.home-3 .living-contact-heading {\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px;\n  color: var(--living-gold-soft);\n  font-family: \"Roboto Slab\", serif;\n  font-size: 18px;\n  text-align: left;\n}\n\n.maderas-elegant.home-3 .living-contact-heading::before {\n  content: \"\";\n  flex: 0 0 26px;\n  height: 1px;\n  margin-right: 10px;\n  background: linear-gradient(90deg, var(--living-gold), transparent);\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact {\n  width: 100%;\n  margin: 0;\n  padding: 0 !important;\n  background: transparent !important;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item {\n  min-height: 64px;\n  margin: 0 0 10px;\n  padding: 10px 12px;\n  gap: 12px;\n  text-align: left;\n  background: linear-gradient(\n    135deg,\n    rgba(196, 217, 234, 0.12),\n    rgba(103, 139, 169, 0.07)\n  ) !important;\n  border: 1px solid var(--living-border-soft);\n  border-radius: 16px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.maderas-elegant.home-3\n  .bostami-parsonal-info-contact-item:last-child {\n  margin-bottom: 0;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .icon {\n  display: grid;\n  flex: 0 0 42px;\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  place-items: center;\n  background: linear-gradient(\n    145deg,\n    rgba(238, 247, 255, 0.24),\n    rgba(139, 172, 199, 0.15)\n  ) !important;\n  border: 1px solid var(--living-border-soft);\n  border-radius: 13px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24);\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .icon i {\n  color: var(--living-gold-soft) !important;\n  font-size: 17px;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text {\n  flex: 1;\n  min-width: 0;\n  align-items: flex-start;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text span {\n  margin: 0 0 3px;\n  color: var(--living-text-muted) !important;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.2;\n  text-transform: none;\n  letter-spacing: 0.035em;\n}\n\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text p,\n.maderas-elegant.home-3 .bostami-parsonal-info-contact-item .text a {\n  max-width: 100%;\n  margin: 0 !important;\n  color: var(--living-text) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: 1.32;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.maderas-elegant.home-3\n  .bostami-parsonal-info-contact-item\n  .text\n  a:hover {\n  color: var(--living-gold-soft) !important;\n}\n\n.maderas-elegant.home-3 .living-content-column {\n  position: relative;\n  grid-area: content;\n  min-width: 0;\n  align-self: center;\n}\n\n.maderas-elegant.home-3 .living-profile-column,\n.maderas-elegant.home-3 .living-content-column {\n  margin-top: clamp(28px, 3.2vw, 48px);\n}\n\n.maderas-elegant.home-3 .bostami-page-content-wrap {\n  position: relative;\n  min-height: 485px;\n  overflow: hidden;\n  color: var(--living-text);\n  background: var(--living-glass) !important;\n  border: 1px solid var(--living-border) !important;\n  border-radius: 30px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.32),\n    var(--living-shadow);\n  backdrop-filter: blur(25px) saturate(120%);\n  -webkit-backdrop-filter: blur(25px) saturate(120%);\n  animation: living-panel-in 420ms ease both;\n}\n\n.maderas-elegant.home-3 .bostami-page-content-wrap::before {\n  height: 48%;\n  opacity: 0.7;\n  background:\n    radial-gradient(\n      circle at 8% 0%,\n      rgba(255, 255, 255, 0.15),\n      transparent 28%\n    ),\n    linear-gradient(\n      120deg,\n      rgba(255, 255, 255, 0.08),\n      transparent 34%\n    );\n}\n\n.maderas-elegant.home-3 .living-about-panel {\n  min-height: 255px;\n}\n\n.maderas-elegant.home-3 .living-about-section {\n  position: relative;\n  z-index: 1;\n  padding: clamp(34px, 4vw, 52px) clamp(30px, 4.4vw, 58px) 28px;\n}\n\n.maderas-elegant.home-3 .living-section-heading {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  margin-bottom: 18px;\n}\n\n.maderas-elegant.home-3 .living-section-heading > span {\n  width: clamp(74px, 12vw, 130px);\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    var(--living-gold),\n    rgba(216, 185, 120, 0.15)\n  );\n}\n\n.maderas-elegant.home-3 .page-title,\n.maderas-elegant.home-3 .section-title {\n  margin: 0;\n  color: var(--living-text) !important;\n  font-family: \"Roboto Slab\", serif;\n  font-weight: 400;\n  text-transform: none;\n}\n\n.maderas-elegant.home-3 .page-title {\n  font-size: clamp(34px, 3.5vw, 44px);\n  line-height: 1.05;\n  letter-spacing: -0.025em;\n}\n\n.maderas-elegant.home-3 .section-title {\n  font-size: clamp(25px, 2.5vw, 31px);\n  line-height: 1.1;\n}\n\n.maderas-elegant.home-3 .page-title::after,\n.maderas-elegant.home-3 .bostami-page-title-wrap::after {\n  display: none;\n}\n\n.maderas-elegant.home-3 .bostami-page-title-wrap p,\n.maderas-elegant.home-3 .section-wrapper p {\n  max-width: 720px;\n  margin: 0 0 10px;\n  color: var(--living-text) !important;\n  font-size: clamp(14px, 1.25vw, 16px);\n  font-weight: 400;\n  line-height: 1.75;\n  opacity: 0.92;\n}\n\n.maderas-elegant.home-3 .living-content-column > .bostami-page-content-wrap {\n  width: 100%;\n}\n\n.maderas-elegant.home-3\n  .living-content-column\n  .section-wrapper:not(.living-about-section) {\n  padding-right: clamp(28px, 4vw, 54px) !important;\n  padding-left: clamp(28px, 4vw, 54px) !important;\n}\n\n.maderas-elegant.home-3\n  .living-content-column\n  .section-wrapper.pt-60 {\n  padding-top: clamp(34px, 4vw, 50px) !important;\n}\n\n.maderas-elegant.home-3 .contact-area {\n  padding: 10px 0 0;\n}\n\n.maderas-elegant.home-3 .form-input-item label {\n  color: var(--living-text-soft) !important;\n}\n\n.maderas-elegant.home-3 .form-input-item .input-box {\n  color: var(--living-text) !important;\n  background: rgba(199, 220, 237, 0.1) !important;\n  border: 1px solid var(--living-border-soft) !important;\n  border-radius: 15px !important;\n}\n\n.maderas-elegant.home-3 .form-input-item .input-box:focus {\n  background: rgba(210, 228, 242, 0.15) !important;\n  border-color: rgba(240, 217, 157, 0.72) !important;\n  box-shadow: 0 0 0 3px rgba(216, 185, 120, 0.12) !important;\n}\n\n.maderas-elegant.home-3 .form-btn {\n  color: #122436 !important;\n  background: linear-gradient(\n    135deg,\n    var(--living-gold-soft),\n    var(--living-gold)\n  ) !important;\n  animation: none !important;\n}\n\n.maderas-elegant.home-3 .form-btn:disabled {\n  cursor: wait;\n  opacity: 0.68;\n  transform: none !important;\n}\n\n.maderas-elegant.home-3 .fillter-btn,\n.maderas-elegant.home-3 .fillter-item {\n  background: rgba(192, 215, 233, 0.1) !important;\n  border-color: var(--living-border-soft) !important;\n}\n\n.maderas-elegant.home-3 .fillter-btn {\n  color: var(--living-text-soft) !important;\n}\n\n.maderas-elegant.home-3 .fillter-btn:hover,\n.maderas-elegant.home-3 .fillter-btn.is-checked {\n  color: #122436 !important;\n  background: linear-gradient(\n    135deg,\n    var(--living-gold-soft),\n    var(--living-gold)\n  ) !important;\n}\n\n.maderas-elegant.home-3 .fillter-item .item-title {\n  color: var(--living-text) !important;\n}\n\n.maderas-elegant.home-3 .fillter-item .item-subtitle {\n  color: var(--living-text-muted) !important;\n}\n\n.maderas-elegant.home-3 .development-card-trigger {\n  display: block;\n  width: 100%;\n  padding: 0;\n  color: inherit;\n  text-align: left;\n  background: transparent;\n  border: 0;\n}\n\n.maderas-elegant.home-3 .development-card-trigger .img img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.maderas-elegant.home-3 .development-card-trigger .item-title {\n  display: block;\n}\n\n/* Development modal */\n.maderas-elegant.home-3 .development-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1090;\n  display: grid !important;\n  place-items: center;\n  width: 100%;\n  height: 100%;\n  padding: clamp(14px, 3vw, 34px);\n  overflow: hidden;\n  background: rgba(2, 12, 23, 0.74);\n  backdrop-filter: blur(10px) saturate(115%);\n  -webkit-backdrop-filter: blur(10px) saturate(115%);\n  animation: living-modal-backdrop-in 220ms ease both;\n}\n\n.maderas-elegant.home-3 .development-modal .modal-dialog {\n  width: min(860px, 100%);\n  max-width: 860px;\n  max-height: calc(100dvh - clamp(28px, 6vw, 68px));\n  margin: 0;\n  animation: living-modal-card-in 320ms ease both;\n}\n\n.maderas-elegant.home-3 .development-modal .modal-content {\n  max-height: inherit;\n  overflow: hidden;\n  color: var(--living-text);\n  background: var(--living-glass-strong);\n  border: 1px solid var(--living-border);\n  border-radius: 30px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.3),\n    0 34px 90px rgba(0, 8, 20, 0.52);\n  backdrop-filter: blur(28px) saturate(125%);\n  -webkit-backdrop-filter: blur(28px) saturate(125%);\n}\n\n.maderas-elegant.home-3 .development-modal .modal-body {\n  padding: clamp(22px, 3.5vw, 34px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-color: var(--living-gold) rgba(223, 236, 247, 0.12);\n  scrollbar-width: thin;\n}\n\n.maderas-elegant.home-3 .development-modal .modal-body::-webkit-scrollbar {\n  width: 7px;\n}\n\n.maderas-elegant.home-3\n  .development-modal\n  .modal-body::-webkit-scrollbar-track {\n  background: rgba(223, 236, 247, 0.12);\n  border-radius: 10px;\n}\n\n.maderas-elegant.home-3\n  .development-modal\n  .modal-body::-webkit-scrollbar-thumb {\n  background: var(--living-gold);\n  border-radius: 10px;\n}\n\n.maderas-elegant.home-3 .development-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 2;\n  display: grid;\n  place-items: center;\n  width: 42px;\n  height: 42px;\n  padding: 0;\n  color: var(--living-text);\n  background: var(--theme-card-bg);\n  border: 1px solid var(--living-border);\n  border-radius: 50%;\n  box-shadow: 0 8px 24px rgba(0, 8, 20, 0.3);\n  transition:\n    color 180ms ease,\n    background 180ms ease,\n    border-color 180ms ease,\n    transform 180ms ease;\n}\n\n.maderas-elegant.home-3 .development-modal__close:hover {\n  color: #122436;\n  background: var(--living-gold-soft);\n  border-color: var(--living-gold-soft);\n  transform: rotate(90deg);\n}\n\n.maderas-elegant.home-3 .development-modal__image {\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 16 / 5;\n  margin-bottom: clamp(24px, 3vw, 32px);\n  border: 1px solid var(--living-border-soft);\n  border-radius: 20px;\n  box-shadow: 0 16px 34px rgba(0, 8, 20, 0.24);\n}\n\n.maderas-elegant.home-3 .development-modal__image::after {\n  position: absolute;\n  inset: 0;\n  content: \"\";\n  pointer-events: none;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);\n}\n\n.maderas-elegant.home-3 .development-modal__image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.maderas-elegant.home-3 .development-modal__details {\n  padding: 0 clamp(2px, 1vw, 8px) 2px;\n}\n\n.maderas-elegant.home-3 .development-modal__heading {\n  padding-right: 42px;\n  margin-bottom: 18px;\n}\n\n.maderas-elegant.home-3 .development-modal__heading > span {\n  display: block;\n  margin-bottom: 7px;\n  color: var(--living-gold-soft);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.maderas-elegant.home-3 .development-modal__heading h2 {\n  margin: 0;\n  color: var(--living-text);\n  font-family: \"Roboto Slab\", serif;\n  font-size: clamp(26px, 3vw, 34px);\n  font-weight: 400;\n  line-height: 1.16;\n}\n\n.maderas-elegant.home-3 .development-modal__description {\n  margin-bottom: 26px;\n  color: var(--living-text-soft);\n  font-size: 15px;\n  line-height: 1.75;\n  overflow-wrap: anywhere;\n}\n\n.maderas-elegant.home-3 .development-modal__description > :last-child {\n  margin-bottom: 0;\n}\n\n.maderas-elegant.home-3 .development-modal__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.maderas-elegant.home-3 .development-modal__actions:empty {\n  display: none;\n}\n\n.maderas-elegant.home-3 .development-modal__actions :is(a, button) {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 11px 20px;\n  color: var(--living-text);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  background: rgba(192, 215, 233, 0.1);\n  border: 1px solid var(--living-border-soft);\n  border-radius: 14px;\n  transition:\n    color 180ms ease,\n    background 180ms ease,\n    border-color 180ms ease,\n    transform 180ms ease,\n    box-shadow 180ms ease;\n}\n\n.maderas-elegant.home-3 .development-modal__actions :is(a, button) i {\n  margin-right: 10px;\n  color: var(--living-gold-soft);\n  font-size: 16px;\n}\n\n.maderas-elegant.home-3 .development-modal__actions :is(a, button):hover {\n  color: #122436;\n  background: linear-gradient(\n    135deg,\n    var(--living-gold-soft),\n    var(--living-gold)\n  );\n  border-color: transparent;\n  box-shadow: 0 10px 24px rgba(0, 8, 20, 0.2);\n  transform: translateY(-2px);\n}\n\n.maderas-elegant.home-3 .development-modal__actions :is(a, button):hover i {\n  color: #122436;\n}\n\n@keyframes living-modal-backdrop-in {\n  from {\n    opacity: 0;\n  }\n}\n\n@keyframes living-modal-card-in {\n  from {\n    opacity: 0;\n    transform: translateY(16px) scale(0.98);\n  }\n}\n\n@media (max-width: 575px) {\n  .maderas-elegant.home-3 .development-modal {\n    padding: 12px;\n  }\n\n  .maderas-elegant.home-3 .development-modal .modal-dialog {\n    max-height: calc(100dvh - 24px);\n  }\n\n  .maderas-elegant.home-3 .development-modal .modal-content {\n    border-radius: 22px;\n  }\n\n  .maderas-elegant.home-3 .development-modal .modal-body {\n    padding: 16px;\n  }\n\n  .maderas-elegant.home-3 .development-modal__close {\n    top: 10px;\n    right: 10px;\n    width: 38px;\n    height: 38px;\n  }\n\n  .maderas-elegant.home-3 .development-modal__image {\n    aspect-ratio: 16 / 7;\n    margin-bottom: 22px;\n    border-radius: 15px;\n  }\n\n  .maderas-elegant.home-3 .development-modal__heading {\n    padding-right: 0;\n  }\n\n  .maderas-elegant.home-3 .development-modal__description {\n    margin-bottom: 22px;\n    font-size: 14px;\n    line-height: 1.65;\n  }\n\n  .maderas-elegant.home-3 .development-modal__actions {\n    flex-direction: column;\n  }\n\n  .maderas-elegant.home-3 .development-modal__actions :is(a, button) {\n    width: 100%;\n  }\n}\n\n.maderas-elegant.home-3 .footer-copyright {\n  color: var(--living-text-muted) !important;\n  background: rgba(3, 16, 30, 0.1) !important;\n  border-color: var(--living-border-soft) !important;\n}\n\n.maderas-elegant.home-3 .elegant-curve-bg,\n.maderas-elegant.home-3 .elegant-curve-bg-2 {\n  position: absolute;\n  z-index: 4;\n  width: 68px;\n  height: 68px;\n  pointer-events: none;\n  background:\n    radial-gradient(\n      circle at 32% 26%,\n      rgba(255, 255, 255, 0.72),\n      rgba(255, 255, 255, 0.12) 18%,\n      rgba(97, 142, 178, 0.2) 42%,\n      rgba(6, 27, 46, 0.22) 72%\n    );\n  border: 1px solid rgba(231, 241, 249, 0.46);\n  border-radius: 50%;\n  box-shadow:\n    inset -10px -12px 22px rgba(2, 16, 31, 0.24),\n    inset 8px 7px 16px rgba(255, 255, 255, 0.12),\n    0 12px 30px rgba(0, 8, 20, 0.28);\n  opacity: 0.74;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.maderas-elegant.home-3 .elegant-curve-bg {\n  top: -26px;\n  right: auto;\n  left: -28px;\n  transform: none;\n}\n\n.maderas-elegant.home-3 .elegant-curve-bg-2 {\n  top: auto;\n  right: -28px;\n  bottom: -28px;\n  left: auto;\n  transform: none;\n}\n\n.maderas-elegant.home-3 :is(a, button):focus-visible {\n  outline: 2px solid var(--living-gold-soft);\n  outline-offset: 3px;\n}\n\n@keyframes living-panel-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .maderas-elegant.home-3 {\n    padding-top: 20px;\n  }\n\n  .maderas-elegant.home-3 .living-dashboard {\n    grid-template-columns: minmax(286px, 318px) minmax(0, 1fr);\n    column-gap: 24px;\n    width: min(100% - 30px, 1140px);\n  }\n\n  .maderas-elegant.home-3 .living-brand-lockup {\n    padding: 10px 16px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-mark {\n    margin-right: -34px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-script {\n    font-size: 27px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-copy strong {\n    font-size: 17px;\n  }\n\n  .maderas-elegant.home-3\n    .bastami-main-menu\n    .menu-item-content {\n    padding: 9px 10px;\n  }\n\n  .maderas-elegant.home-3 .menu-item-content .icon {\n    margin-right: 6px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-area {\n    padding: 22px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-img img {\n    width: 220px;\n    height: 220px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-photo {\n    width: 220px;\n    height: 220px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-name {\n    font-size: 25px;\n  }\n}\n\n@media (min-width: 992px) and (max-height: 820px) {\n  .maderas-elegant.home-3 {\n    padding: 14px 0 24px;\n  }\n\n  .maderas-elegant.home-3 .living-dashboard {\n    row-gap: 14px;\n    min-height: calc(100vh - 38px);\n  }\n\n  .maderas-elegant.home-3 .living-profile-column,\n  .maderas-elegant.home-3 .living-content-column {\n    margin-top: 20px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-lockup {\n    min-height: 72px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  .maderas-elegant.home-3\n    .bastami-main-menu\n    .menu-item-content {\n    min-height: 50px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-area {\n    padding: 19px 22px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-img {\n    margin-bottom: 12px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-img img {\n    width: 205px;\n    height: 205px;\n    border-radius: 25px !important;\n  }\n\n  .maderas-elegant.home-3 .living-loading-profile {\n    min-height: 0;\n  }\n\n  .maderas-elegant.home-3 .living-loading-photo {\n    width: 205px;\n    height: 205px;\n    margin-bottom: 12px;\n    border-radius: 25px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-name {\n    height: 26px;\n    margin-bottom: 7px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-badge {\n    height: 27px;\n    margin-bottom: 10px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-socials {\n    min-height: 38px;\n    margin-bottom: 11px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-socials > span {\n    width: 38px;\n    height: 38px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-heading {\n    height: 18px;\n    margin-bottom: 7px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-contact {\n    min-height: 53px;\n    margin-bottom: 7px;\n    padding: 7px 10px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-contact__icon {\n    flex-basis: 36px;\n    width: 36px;\n    height: 36px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-name {\n    margin-bottom: 7px;\n    font-size: 24px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-bio {\n    min-height: 27px;\n    margin-bottom: 10px;\n    padding: 4px 16px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-social-link {\n    min-height: 38px;\n    margin-bottom: 11px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-social-link li a {\n    width: 38px;\n    height: 38px;\n  }\n\n  .maderas-elegant.home-3 .living-contact-heading {\n    margin-bottom: 7px;\n    font-size: 16px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-contact-item {\n    min-height: 53px;\n    margin-bottom: 7px;\n    padding: 7px 10px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-contact-item .icon {\n    flex-basis: 36px;\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n  }\n\n  .maderas-elegant.home-3 .bostami-page-content-wrap {\n    min-height: 430px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-content__card {\n    min-height: 430px;\n    padding-top: 30px;\n    padding-bottom: 24px;\n  }\n\n  .maderas-elegant.home-3 .living-about-section {\n    padding-top: 30px;\n    padding-bottom: 20px;\n  }\n\n  .maderas-elegant.home-3 .living-section-heading {\n    margin-bottom: 12px;\n  }\n\n  .maderas-elegant.home-3 .page-title {\n    font-size: 36px;\n  }\n\n  .maderas-elegant.home-3 .bostami-page-title-wrap p,\n  .maderas-elegant.home-3 .section-wrapper p {\n    margin-bottom: 7px;\n    font-size: 14px;\n    line-height: 1.58;\n  }\n\n  .maderas-elegant.home-3 .section-title {\n    font-size: 26px;\n  }\n\n  .maderas-elegant.home-3 .living-about-panel {\n    min-height: 235px;\n  }\n}\n\n@media (max-width: 991px) {\n  .maderas-elegant.home-3 {\n    height: auto;\n    min-height: 100vh;\n    padding: 20px 0 34px;\n    overflow-y: visible;\n    background-attachment: scroll;\n  }\n\n  .maderas-elegant.home-3 .living-dashboard {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-areas:\n      \"brand\"\n      \"navigation\"\n      \"profile\"\n      \"content\";\n    gap: 18px;\n    width: min(100% - 30px, 720px);\n    min-height: auto;\n  }\n\n  .maderas-elegant.home-3 .living-brand-bar,\n  .maderas-elegant.home-3 .living-navigation,\n  .maderas-elegant.home-3 .living-profile-column,\n  .maderas-elegant.home-3 .living-content-column {\n    width: 100%;\n  }\n\n  .maderas-elegant.home-3 .living-brand-lockup {\n    padding-right: 76px;\n  }\n\n  .maderas-elegant.home-3 .theme-toggle-btn {\n    right: 14px;\n  }\n\n  .maderas-elegant.home-3 .living-profile-column,\n  .maderas-elegant.home-3 .living-content-column {\n    margin-top: 0;\n  }\n\n  .maderas-elegant.home-3 .living-navigation {\n    justify-self: stretch;\n  }\n\n  .maderas-elegant.home-3 .bostami-main-menu-wrap {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n\n  .maderas-elegant.home-3 .bastami-main-menu ul {\n    display: grid !important;\n    grid-template-columns: repeat(3, 1fr);\n    width: 100%;\n    padding: 0;\n  }\n\n  .maderas-elegant.home-3 .bastami-main-menu ul li {\n    width: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .maderas-elegant.home-3\n    .bastami-main-menu\n    .menu-item-content {\n    flex-direction: row;\n    min-height: 54px;\n  }\n\n  .maderas-elegant.home-3 .menu-item-content .icon {\n    margin: 0 7px 0 0 !important;\n    font-size: 18px !important;\n  }\n\n  .maderas-elegant.home-3 .menu-item-content .text {\n    font-size: 13px !important;\n    text-transform: none;\n  }\n\n  .maderas-elegant.home-3 .living-profile-column {\n    max-width: 540px;\n    margin: 0 auto;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-img img {\n    height: 258px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-photo {\n    width: 258px;\n    height: 258px;\n  }\n\n  .maderas-elegant.home-3 .elegant-curve-bg {\n    top: -22px;\n    left: -18px;\n  }\n\n  .maderas-elegant.home-3 .elegant-curve-bg-2 {\n    right: -18px;\n    bottom: -22px;\n  }\n}\n\n@media (max-width: 575px) {\n  .maderas-elegant.home-3 {\n    padding-top: 14px;\n  }\n\n  .maderas-elegant.home-3 .living-dashboard {\n    gap: 14px;\n    width: min(100% - 22px, 540px);\n  }\n\n  .maderas-elegant.home-3 .elegant-curve-bg,\n  .maderas-elegant.home-3 .elegant-curve-bg-2 {\n    width: 56px;\n    height: 56px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-lockup {\n    min-height: 72px;\n    padding: 8px 66px 8px 14px;\n    border-radius: 20px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-mark {\n    flex-basis: 50px;\n    width: 50px;\n    height: 44px;\n    margin-right: -30px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-mark::before {\n    top: 8px;\n    left: 10px;\n    width: 29px;\n    height: 29px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-mark::after {\n    height: 23px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-script {\n    margin-right: 5px;\n    font-size: 24px;\n  }\n\n  .maderas-elegant.home-3 .living-brand-copy strong {\n    font-size: 15px;\n  }\n\n  .maderas-elegant.home-3 .theme-toggle-btn {\n    right: 10px;\n    width: 44px;\n    height: 44px;\n  }\n\n  .maderas-elegant.home-3 .bostami-main-menu-wrap {\n    padding: 5px;\n    border-radius: 19px;\n  }\n\n  .maderas-elegant.home-3\n    .bastami-main-menu\n    .menu-item-content {\n    flex-direction: column;\n    min-height: 68px;\n    padding: 7px 3px;\n  }\n\n  .maderas-elegant.home-3 .menu-item-content .icon {\n    width: 28px;\n    height: 28px;\n    margin: 0 0 4px !important;\n    border-radius: 9px;\n    font-size: 15px !important;\n  }\n\n  .maderas-elegant.home-3 .menu-item-content .text {\n    max-width: 100%;\n    overflow: hidden;\n    font-size: 10px !important;\n    text-overflow: ellipsis;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-area {\n    padding: 22px 18px;\n    border-radius: 25px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-img img {\n    width: min(100%, 240px);\n    height: 240px;\n    border-radius: 26px !important;\n  }\n\n  .maderas-elegant.home-3 .living-loading-photo {\n    width: min(100%, 240px);\n    height: 240px;\n    border-radius: 26px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-content__card {\n    min-height: 420px;\n    padding: 30px 22px 24px;\n  }\n\n  .maderas-elegant.home-3 .living-loading-title {\n    height: 36px;\n  }\n\n  .maderas-elegant.home-3 .bostami-parsonal-info-name {\n    font-size: 25px;\n  }\n\n  .maderas-elegant.home-3 .living-about-section {\n    padding: 30px 22px 24px;\n  }\n\n  .maderas-elegant.home-3 .living-section-heading {\n    gap: 14px;\n  }\n\n  .maderas-elegant.home-3 .living-section-heading > span {\n    min-width: 38px;\n  }\n\n  .maderas-elegant.home-3 .page-title {\n    font-size: 34px;\n  }\n\n  .maderas-elegant.home-3 .section-title {\n    font-size: 23px;\n  }\n\n  .maderas-elegant.home-3\n    .living-content-column\n    .section-wrapper:not(.living-about-section) {\n    padding-right: 22px !important;\n    padding-left: 22px !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .maderas-elegant.home-3 *,\n  .maderas-elegant.home-3 *::before,\n  .maderas-elegant.home-3 *::after {\n    scroll-behavior: auto !important;\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Living Maderas QR view */\n.maderas-elegant.qr-view-container {\n  --living-gold: #d8b978;\n  --living-gold-soft: #f0d99d;\n  --living-text: #f8fbff;\n  --living-text-soft: rgba(234, 242, 250, 0.78);\n  --living-text-muted: rgba(224, 234, 244, 0.58);\n  --living-glass: linear-gradient(\n    150deg,\n    rgba(44, 67, 91, 0.76) 0%,\n    rgba(8, 26, 45, 0.7) 58%,\n    rgba(5, 18, 33, 0.78) 100%\n  );\n  --living-glass-soft: rgba(164, 191, 216, 0.1);\n  --living-border: rgba(227, 239, 250, 0.38);\n  --living-border-soft: rgba(227, 239, 250, 0.17);\n  --living-shadow: 0 28px 70px rgba(0, 8, 20, 0.42);\n  display: block !important;\n  min-height: 100vh !important;\n  padding: 42px 18px 34px !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-attachment: fixed;\n  isolation: isolate;\n}\n\n.maderas-elegant.qr-view-container.light-theme {\n  --living-text: #11263b;\n  --living-text-soft: rgba(17, 38, 59, 0.78);\n  --living-text-muted: rgba(17, 38, 59, 0.6);\n  --living-glass: linear-gradient(\n    150deg,\n    rgba(255, 255, 255, 0.88) 0%,\n    rgba(229, 240, 249, 0.78) 58%,\n    rgba(213, 229, 241, 0.82) 100%\n  );\n  --living-glass-soft: rgba(255, 255, 255, 0.42);\n  --living-border: rgba(255, 255, 255, 0.72);\n  --living-border-soft: rgba(255, 255, 255, 0.48);\n  --living-shadow: 0 26px 66px rgba(6, 27, 47, 0.25);\n}\n\n.maderas-elegant.qr-view-container .living-background-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n  background:\n    linear-gradient(\n      90deg,\n      rgba(1, 12, 27, 0.62) 0%,\n      rgba(4, 18, 34, 0.3) 48%,\n      rgba(2, 14, 29, 0.4) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(2, 13, 27, 0.16) 0%,\n      transparent 44%,\n      rgba(1, 10, 22, 0.48) 100%\n    );\n}\n\n.maderas-elegant.qr-view-container.light-theme\n  .living-background-overlay {\n  background:\n    linear-gradient(\n      90deg,\n      rgba(9, 27, 47, 0.36) 0%,\n      rgba(16, 37, 57, 0.12) 48%,\n      rgba(7, 23, 40, 0.22) 100%\n    ),\n    linear-gradient(\n      180deg,\n      rgba(209, 228, 242, 0.08) 0%,\n      transparent 50%,\n      rgba(3, 17, 32, 0.26) 100%\n    );\n}\n\n.maderas-elegant.qr-view-container .qr-content-wrapper {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: min(100%, 430px);\n  max-width: 430px;\n  margin: 0 auto;\n}\n\n.maderas-elegant.qr-view-container .living-brand-bar {\n  position: relative;\n  z-index: 5;\n  width: 100%;\n}\n\n.maderas-elegant.qr-view-container .living-brand-lockup {\n  padding-right: 84px;\n}\n\n.maderas-elegant.qr-view-container .theme-toggle-btn {\n  position: absolute;\n  top: 50%;\n  right: 18px;\n  z-index: 6;\n  width: 48px;\n  height: 48px;\n  color: var(--living-gold-soft);\n  background: rgba(9, 28, 48, 0.68);\n  border: 1px solid var(--living-border);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.18),\n    0 12px 26px rgba(0, 8, 20, 0.28);\n  transform: translateY(-50%);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n}\n\n.maderas-elegant.qr-view-container .theme-toggle-btn:hover {\n  transform: translateY(-50%) scale(1.06);\n}\n\n.maderas-elegant.qr-view-container :is(a, button):focus-visible {\n  outline: 2px solid var(--living-gold-soft);\n  outline-offset: 3px;\n}\n\n.maderas-elegant.qr-view-container.light-theme .theme-toggle-btn {\n  color: #8e6d31;\n  background: rgba(241, 248, 253, 0.76);\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-area {\n  position: relative;\n  width: 100% !important;\n  max-width: none !important;\n  margin: 102px 0 0 !important;\n  padding: 112px 30px 30px;\n  overflow: visible;\n  color: var(--living-text);\n  background: var(--living-glass) !important;\n  border: 1px solid var(--living-border) !important;\n  border-radius: 30px;\n  box-shadow:\n    -22px 18px 48px rgba(2, 12, 23, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.22),\n    var(--living-shadow);\n  backdrop-filter: blur(24px) saturate(120%);\n  -webkit-backdrop-filter: blur(24px) saturate(120%);\n  isolation: isolate;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-area::before {\n  position: absolute;\n  inset: 14px auto 14px -18px;\n  z-index: -1;\n  width: 45px;\n  content: \"\";\n  background: linear-gradient(\n    180deg,\n    rgba(168, 199, 225, 0.2),\n    rgba(5, 18, 33, 0.06)\n  );\n  border-radius: 28px 0 0 28px;\n  filter: blur(8px);\n  opacity: 0.72;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-area::after {\n  position: absolute;\n  top: 0;\n  left: 32px;\n  width: 46%;\n  height: 2px;\n  content: \"\";\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.9),\n    var(--living-gold-soft),\n    transparent\n  );\n  filter: blur(0.2px);\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-wrap {\n  position: relative;\n  z-index: 2;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-img {\n  position: absolute !important;\n  top: -198px;\n  left: 50%;\n  margin: 0 !important;\n  transform: translateX(-50%);\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-img img {\n  display: block;\n  width: 172px !important;\n  height: 172px !important;\n  padding: 4px;\n  object-fit: cover;\n  background: rgba(10, 28, 47, 0.64) !important;\n  border: 1px solid var(--living-gold-soft) !important;\n  border-radius: 28px !important;\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.42),\n    0 14px 32px rgba(0, 8, 20, 0.36),\n    0 0 20px rgba(216, 185, 120, 0.22);\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-name {\n  max-width: 340px;\n  margin: 0 auto 10px !important;\n  color: var(--living-text) !important;\n  font-family: \"Roboto Slab\", serif;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.12;\n  text-transform: none;\n  letter-spacing: 0;\n  text-wrap: balance;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-name span {\n  color: inherit !important;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-bio {\n  display: table;\n  margin: 0 auto 22px;\n  padding: 5px 22px;\n  color: var(--living-text) !important;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(240, 217, 157, 0.78),\n    rgba(142, 109, 49, 0.72)\n  ) !important;\n  border: 1px solid rgba(240, 217, 157, 0.5);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n}\n\n.maderas-elegant.qr-view-container .qr-code-container {\n  display: grid;\n  width: min(100%, 250px);\n  margin: 0 auto 24px;\n  padding: 20px;\n  place-items: center;\n  background: linear-gradient(\n    145deg,\n    rgba(169, 193, 214, 0.12),\n    rgba(3, 17, 31, 0.26)\n  );\n  border: 1px solid rgba(216, 185, 120, 0.5);\n  border-radius: 22px;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.14),\n    0 14px 32px rgba(0, 8, 20, 0.2),\n    0 0 24px rgba(216, 185, 120, 0.1);\n}\n\n.maderas-elegant.qr-view-container.light-theme .qr-code-container {\n  background: rgba(255, 255, 255, 0.42);\n}\n\n.maderas-elegant.qr-view-container .qr-code-canvas {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.maderas-elegant.qr-view-container .bostami-parsonal-info-contact {\n  width: 100% !important;\n  padding: 0 !important;\n  background: transparent !important;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item {\n  min-height: 62px;\n  margin: 0 0 10px;\n  padding: 9px 11px !important;\n  gap: 12px;\n  text-align: left;\n  background: linear-gradient(\n    135deg,\n    rgba(180, 205, 226, 0.13),\n    rgba(4, 18, 33, 0.14)\n  ) !important;\n  border: 1px solid var(--living-border-soft);\n  border-radius: 16px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item:last-child {\n  margin-bottom: 0;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item\n  .icon {\n  display: grid;\n  flex: 0 0 42px;\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  place-items: center;\n  background: linear-gradient(\n    145deg,\n    rgba(222, 231, 239, 0.26),\n    rgba(112, 137, 161, 0.16)\n  ) !important;\n  border: 1px solid var(--living-border-soft);\n  border-radius: 13px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24);\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item\n  .icon\n  i {\n  color: var(--living-gold-soft) !important;\n  font-size: 17px;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item\n  .text {\n  flex: 1;\n  min-width: 0;\n  align-items: flex-start;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item\n  .text\n  span {\n  margin: 0 0 3px;\n  color: var(--living-text-muted) !important;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.2;\n  text-transform: none;\n  letter-spacing: 0.035em;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item\n  .text\n  a {\n  max-width: 100%;\n  margin: 0 !important;\n  color: var(--living-text) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  line-height: 1.35;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: normal !important;\n}\n\n.maderas-elegant.qr-view-container\n  .bostami-parsonal-info-contact-item\n  .text\n  a:hover {\n  color: var(--living-gold-soft) !important;\n}\n\n.maderas-elegant.qr-view-container .elegant-curve-bg,\n.maderas-elegant.qr-view-container .elegant-curve-bg-2 {\n  position: absolute;\n  z-index: 4;\n  width: 64px;\n  height: 64px;\n  pointer-events: none;\n  background: radial-gradient(\n    circle at 32% 26%,\n    rgba(255, 255, 255, 0.72),\n    rgba(255, 255, 255, 0.12) 18%,\n    rgba(97, 142, 178, 0.2) 42%,\n    rgba(6, 27, 46, 0.22) 72%\n  );\n  border: 1px solid rgba(231, 241, 249, 0.46);\n  border-radius: 50%;\n  box-shadow:\n    inset -10px -12px 22px rgba(2, 16, 31, 0.24),\n    inset 8px 7px 16px rgba(255, 255, 255, 0.12),\n    0 12px 30px rgba(0, 8, 20, 0.28);\n  opacity: 0.76;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.maderas-elegant.qr-view-container .elegant-curve-bg {\n  top: -24px;\n  right: auto;\n  left: -26px;\n  transform: none;\n}\n\n.maderas-elegant.qr-view-container .elegant-curve-bg-2 {\n  top: auto;\n  right: -26px;\n  bottom: -26px;\n  left: auto;\n  transform: none;\n}\n\n@media (max-width: 575px) {\n  .maderas-elegant.qr-view-container {\n    padding: 34px 11px 26px !important;\n    background-attachment: scroll;\n  }\n\n  .maderas-elegant.qr-view-container .qr-content-wrapper {\n    width: min(100%, 390px);\n  }\n\n  .maderas-elegant.qr-view-container .theme-toggle-btn {\n    width: 44px;\n    height: 44px;\n  }\n\n  .maderas-elegant.qr-view-container .bostami-parsonal-info-area {\n    margin-top: 94px !important;\n    padding: 102px 18px 20px;\n    border-radius: 26px;\n  }\n\n  .maderas-elegant.qr-view-container .bostami-parsonal-info-img {\n    top: -180px;\n  }\n\n  .maderas-elegant.qr-view-container .bostami-parsonal-info-img img {\n    width: 158px !important;\n    height: 158px !important;\n    border-radius: 25px !important;\n  }\n\n  .maderas-elegant.qr-view-container .bostami-parsonal-info-name {\n    font-size: clamp(23px, 7.4vw, 27px);\n  }\n\n  .maderas-elegant.qr-view-container .qr-code-container {\n    width: min(100%, 226px);\n    padding: 16px;\n  }\n\n  .maderas-elegant.qr-view-container .elegant-curve-bg,\n  .maderas-elegant.qr-view-container .elegant-curve-bg-2 {\n    width: 56px;\n    height: 56px;\n  }\n\n  .maderas-elegant.qr-view-container .elegant-curve-bg {\n    top: -20px;\n    left: -18px;\n  }\n\n  .maderas-elegant.qr-view-container .elegant-curve-bg-2 {\n    right: -18px;\n    bottom: -20px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .maderas-elegant.qr-view-container *,\n  .maderas-elegant.qr-view-container *::before,\n  .maderas-elegant.qr-view-container *::after {\n    scroll-behavior: auto !important;\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
